// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { AppResourceTypeView } from "../../app/v1/app_resource";
import { AppUserDomain } from "../../app/v1/app_user";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { UserStatus as UserStatus$ } from "../../user/v1/user";
import { AppResource } from "../../app/v1/app_resource";
import { User } from "../../user/v1/user";
import { PolicyRef } from "../../policy/v1/policy";
import { SortOptions } from "../../search/v1/sort";
import { SlackChannel } from "./accessreview_communication";
import { Duration } from "../../../../google/protobuf/duration";
import { AppUser } from "../../app/v1/app_user";
import { App } from "../../app/v1/app";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Any } from "../../../../google/protobuf/any";
import { AppEntitlement } from "../../app/v1/app_entitlement";
import { ActorObjectPermissions } from "../../iam/v1/authorization";
import { CloseDecision } from "./accessreview_actions";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.accessreview.v1.SingleAppSetup
 */
export interface SingleAppSetup {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.MultiAppEntitlement
 */
export interface MultiAppEntitlement {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string entitlement_ids = 2
     */
    entitlementIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.EntitlementToDetails
 */
export interface EntitlementToDetails {
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.CampaignEntitlementDetails> entitlement_details = 1
     */
    entitlementDetails: {
        [key: string]: CampaignEntitlementDetails;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.CampaignEntitlementDetails
 */
export interface CampaignEntitlementDetails {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: string policy_id = 3
     */
    policyId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.MultiAppSetup
 */
export interface MultiAppSetup {
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.MultiAppEntitlement> app_entitlements = 1
     */
    appEntitlements: {
        [key: string]: MultiAppEntitlement;
    };
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.EntitlementToDetails> app_entitlement_details = 2
     */
    appEntitlementDetails: {
        [key: string]: EntitlementToDetails;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.NotificationConfig
 */
export interface NotificationConfig {
    /**
     * @generated from protobuf field: bool send_reminders = 1
     */
    sendReminders: boolean;
    /**
     * @generated from protobuf field: bool send_close = 2
     */
    sendClose: boolean;
    /**
     * @generated from protobuf field: bool send_kickoff = 3
     */
    sendKickoff: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReview
 */
export interface AccessReview {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string created_by_id = 3
     */
    createdById: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewState state = 4
     */
    state: AccessReviewState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string description = 7
     */
    description: string;
    /**
     * @generated from protobuf field: string policy_id = 8
     */
    policyId: string;
    /**
     * @generated from protobuf field: bool auto_resolve = 9
     */
    autoResolve: boolean;
    /**
     * target completion date
     *
     * @generated from protobuf field: google.protobuf.Timestamp completion_date = 10
     */
    completionDate?: Timestamp;
    /**
     * when campaign was actually closed
     *
     * @generated from protobuf field: google.protobuf.Timestamp closed_at = 11
     */
    closedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NotificationConfig notification_config = 12
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 13
     */
    startedAt?: Timestamp;
    /**
     * @generated from protobuf oneof: setup_metadata
     */
    setupMetadata: {
        oneofKind: "singleApp";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SingleAppSetup single_app = 100
         */
        singleApp: SingleAppSetup;
    } | {
        oneofKind: "multiApp";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.MultiAppSetup multi_app = 101
         */
        multiApp: MultiAppSetup;
    } | {
        oneofKind: "bindings";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.BindingObjectSetup bindings = 102
         */
        bindings: BindingObjectSetup;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExclusionScope exclusion_scope = 14
     */
    exclusionScope?: AccessReviewExclusionScope;
    /**
     * AccessReviewScope: This is the previously used exclusion scope used to explicitly filter out
     * access review selections based on selected criteria. The exclusion criteria were
     * inverted on save to specify criteria required to create a selection. Even so it wasn't
     * feasible to migrate this property over to the new system.
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScope scope = 15
     */
    scope?: AccessReviewScope;
    /**
     * AccessReviewInclusionScope: This is the new scope used to exclusively include selections
     * based on selected criteria. Using a new object enabled us to avoid complicated logic
     * merging divergent behaviors while having a feature flag in place and previously
     * configured campaigns using the old way.
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewInclusionScope inclusion_scope = 16
     */
    inclusionScope?: AccessReviewInclusionScope;
    /**
     * @generated from protobuf field: int32 expected_ticket_count = 17
     */
    expectedTicketCount: number;
    /**
     * The ID of the template if the campaign was created from one
     *
     * @generated from protobuf field: string access_review_template_id = 18
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int64 scoping_version = 19
     */
    scopingVersion: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 20
     */
    scopeV2?: AccessReviewScopeV2;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp connector_sources_frozen_at = 21
     */
    connectorSourcesFrozenAt?: Timestamp;
    /**
     * @generated from protobuf field: bool has_accuracy_support = 22
     */
    hasAccuracySupport: boolean;
    /**
     * @generated from protobuf field: string review_instructions = 23
     */
    reviewInstructions: string;
    /**
     * Determines the policy applied to the campaign. Default is false, using the campaign policy.
     * If true, the order of precedence is entitlement → app → campaign policy.
     *
     * @generated from protobuf field: bool use_policy_override = 24
     */
    usePolicyOverride: boolean;
    /**
     * the default view that reviewers will see when they complete their access reviews
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewViewType default_view = 25
     */
    defaultView: AccessReviewViewType;
    /**
     * @generated from protobuf field: bool auto_generate_report = 26
     */
    autoGenerateReport: boolean;
    /**
     * this sets the scope type for the access review
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeType scope_type = 27
     */
    scopeType: AccessReviewScopeType;
    /**
     * this setting is used for access conflict type scope
     *
     * @generated from protobuf field: bool exempt_certified_access_conflicts = 28
     */
    exemptCertifiedAccessConflicts: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewSignatureConfig signature_config = 29
     */
    signatureConfig?: ReviewSignatureConfig;
    /**
     * Auto-start configuration
     *
     * @generated from protobuf field: bool auto_start_campaign = 30
     */
    autoStartCampaign: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp scheduled_start_date = 31
     */
    scheduledStartDate?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccuracyIssueAction accuracy_issue_action = 32
     */
    accuracyIssueAction: AccuracyIssueAction;
    /**
     * Auto-close configuration
     * completion_date is used as the scheduled close date
     *
     * @generated from protobuf field: bool auto_close_campaign = 33
     */
    autoCloseCampaign: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.CloseDecision auto_close_decision = 34
     */
    autoCloseDecision: CloseDecision;
}
/**
 * Signature configuration for access review submissions
 *
 * @generated from protobuf message c1.api.accessreview.v1.ReviewSignatureConfig
 */
export interface ReviewSignatureConfig {
    /**
     * @generated from protobuf field: bool require_signature = 1
     */
    requireSignature: boolean;
    /**
     * @generated from protobuf field: string step_up_provider_id = 2
     */
    stepUpProviderId: string;
    /**
     * @generated from protobuf field: string meaning_of_signature = 3
     */
    meaningOfSignature: string;
    /**
     * @generated from protobuf field: string tsp_url = 4
     */
    tspUrl: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.BindingObjectSetup
 */
export interface BindingObjectSetup {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewScope
 */
export interface AccessReviewScope {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserType app_user_types = 1
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2
     */
    appUserStatuses: AppUserStatus[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewExclusionScope
 */
export interface AccessReviewExclusionScope {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserType app_user_types = 1
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2
     */
    appUserStatuses: AppUserStatus[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.IncludedUserAttributeValue
 */
export interface IncludedUserAttributeValue {
    /**
     * @generated from protobuf field: string value = 1
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.IncludedUserAttributeValues
 */
export interface IncludedUserAttributeValues {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.IncludedUserAttributeValue values = 1
     */
    values: IncludedUserAttributeValue[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewInclusionScope
 */
export interface AccessReviewInclusionScope {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserType app_user_types = 1
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2
     */
    appUserStatuses: AppUserStatus[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.UserStatus user_statuses = 3
     */
    userStatuses: UserStatus[];
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.IncludedUserAttributeValues> multi_user_profile_attributes = 4
     */
    multiUserProfileAttributes: {
        [key: string]: IncludedUserAttributeValues;
    };
    /**
     * @generated from protobuf field: repeated string user_ids = 5
     */
    userIds: string[];
    /**
     * @generated from protobuf field: repeated string manager_ids = 6
     */
    managerIds: string[];
    /**
     * @generated from protobuf field: bool no_account_owners = 7
     */
    noAccountOwners: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewExpandMask
 */
export interface AccessReviewExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask
 */
export interface AccessReviewAppEntitlementExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask
 */
export interface AccessReviewTemplateAppEntitlementExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewView
 */
export interface AccessReviewView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReview access_review = 1
     */
    accessReview?: AccessReview;
    /**
     * @generated from protobuf field: string created_by_user_path = 2
     */
    createdByUserPath: string;
    /**
     * @generated from protobuf field: string policy_path = 4
     */
    policyPath: string;
    /**
     * @generated from protobuf field: c1.api.iam.v1.ActorObjectPermissions object_permissions = 5
     */
    objectPermissions?: ActorObjectPermissions;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppRequest
 */
export interface AccessReviewServiceListEntitlementsWithMultiAppRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AccessReviewAppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewAppEntitlementView
 */
export interface AccessReviewAppEntitlementView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1
     */
    appEntitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * @generated from protobuf field: string policy_path = 3
     */
    policyPath: string;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_resource_path = 5
     */
    appResourcePath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppResponse
 */
export interface AccessReviewServiceListEntitlementsWithMultiAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView list = 1
     */
    list: AccessReviewAppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceGetResponse
 */
export interface AccessReviewServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewView access_review = 1
     */
    accessReview?: AccessReviewView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceCreateResponse
 */
export interface AccessReviewServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewView access_review = 1
     */
    accessReview?: AccessReviewView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceUpdateResponse
 */
export interface AccessReviewServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewView access_review = 1
     */
    accessReview?: AccessReviewView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetAccessReviewSelectionRequest
 */
export interface GetAccessReviewSelectionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string selection_id = 2
     */
    selectionId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionExpandMask
 */
export interface AccessReviewSelectionExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlement
 */
export interface AccessReviewEntitlement {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string access_review_id = 2
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 4
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string policy_id = 5
     */
    policyId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementView
 */
export interface AccessReviewEntitlementView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlement access_review_entitlement = 1
     */
    accessReviewEntitlement?: AccessReviewEntitlement;
    /**
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string policy_path = 4
     */
    policyPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionRef
 */
export interface AccessReviewSelectionRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceRef
 */
export interface AccessReviewConnectorSourceRef {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelection
 */
export interface AccessReviewSelection {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string access_review_id = 2
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
    /**
     * @generated from protobuf field: string app_id = 5
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string entitlement_ids = 6
     */
    entitlementIds: string[];
    /**
     * @generated from protobuf field: string certify_task_id = 7
     */
    certifyTaskId: string;
    /**
     * @generated from protobuf field: string revoke_task_id = 8
     */
    revokeTaskId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSelectionState state = 9
     */
    state: AccessReviewSelectionState;
    /**
     * @generated from protobuf field: string policy_id = 10
     */
    policyId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 11
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 12
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 13
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSelectionView
 */
export interface AccessReviewSelectionView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSelection access_review_selection = 1
     */
    accessReviewSelection?: AccessReviewSelection;
    /**
     * @generated from protobuf field: string app_user_path = 2
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string user_path = 3
     */
    userPath: string;
    /**
     * @generated from protobuf field: string entitlements_path = 4
     */
    entitlementsPath: string;
    /**
     * @generated from protobuf field: string cert_task_path = 5
     */
    certTaskPath: string;
    /**
     * @generated from protobuf field: string app_path = 6
     */
    appPath: string;
    /**
     * @generated from protobuf field: string policy_path = 7
     */
    policyPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceGetRequest
 */
export interface AccessReviewServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 2
     */
    expandMask?: AccessReviewExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceUpdateRequest
 */
export interface AccessReviewServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReview access_review = 1
     */
    accessReview?: AccessReview;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 3
     */
    expandMask?: AccessReviewExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceCreateRequest
 */
export interface AccessReviewServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completion_date = 3
     */
    completionDate?: Timestamp;
    /**
     * @generated from protobuf field: string policy_id = 4
     */
    policyId: string;
    /**
     * @generated from protobuf field: repeated string owner_ids = 5
     */
    ownerIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 6
     */
    expandMask?: AccessReviewExpandMask;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NotificationConfig notification_config = 7
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: string duplicate_from = 8
     */
    duplicateFrom: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeType scope_type = 9
     */
    scopeType: AccessReviewScopeType;
    /**
     * The scope configuration for the access review. When set, this allows configuring
     * the campaign scope at creation time instead of requiring a separate update.
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 10
     */
    scopeV2?: AccessReviewScopeV2;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceDeleteRequest
 */
export interface AccessReviewServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceDeleteResponse
 */
export interface AccessReviewServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceListRequest
 */
export interface AccessReviewServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 3
     */
    expandMask?: AccessReviewExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewServiceListResponse
 */
export interface AccessReviewServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewView list = 1
     */
    list: AccessReviewView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewReportRef
 */
export interface AccessReviewReportRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewReport
 */
export interface AccessReviewReport {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string access_review_id = 2
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string download_url = 3
     */
    downloadUrl: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReportState state = 4
     */
    state: ReportState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: map<int32, string> hashes = 6
     */
    hashes: {
        [key: number]: string;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewReportServiceListRequest
 */
export interface AccessReviewReportServiceListRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewReportRef refs = 6
     */
    refs: AccessReviewReportRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewReportServiceListResponse
 */
export interface AccessReviewReportServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewReport list = 1
     */
    list: AccessReviewReport[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedRequest
 */
export interface AccessReviewConnectorSourceServiceListOutdatedRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 4
     */
    expandMask?: AccessReviewConnectorSourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedResponse
 */
export interface AccessReviewConnectorSourceServiceListOutdatedResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1
     */
    list: AccessReviewConnectorSourceView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp
 */
export interface AccessReviewEntitlementRollupByApp {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 2
     */
    list: AccessReviewEntitlementRollup[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupByAppUser
 */
export interface AccessReviewEntitlementRollupByAppUser {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 2
     */
    list: AccessReviewEntitlementRollup[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollup
 */
export interface AccessReviewEntitlementRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1
     */
    appEntitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: int32 assigned_tasks = 2
     */
    assignedTasks: number;
    /**
     * @generated from protobuf field: int64 completed_tasks_count = 3
     */
    completedTasksCount: number;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_resource_path = 5
     */
    appResourcePath: string;
    /**
     * @generated from protobuf field: string app_path = 6
     */
    appPath: string;
    /**
     * @generated from protobuf field: int64 pending_submission_count = 7
     */
    pendingSubmissionCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask
 */
export interface AccessReviewEntitlementRollupExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask
 */
export interface AccessReviewEntitlementPreviewExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchRequest
 */
export interface AccessReviewEntitlementPreviewServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask expand_mask = 7
     */
    expandMask?: AccessReviewEntitlementPreviewExpandMask;
    /**
     * @generated from protobuf field: string access_review_id = 8
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreview
 */
export interface AccessReviewEntitlementPreview {
    /**
     * @generated from protobuf field: string app_user_id = 1
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp entitlement_expiration_time = 5
     */
    entitlementExpirationTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp entitlement_discovered_time = 6
     */
    entitlementDiscoveredTime?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewView
 */
export interface AccessReviewEntitlementPreviewView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewEntitlementPreview scope = 1
     */
    scope?: AccessReviewEntitlementPreview;
    /**
     * @generated from protobuf field: string app_user_path = 2
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4
     */
    appPath: string;
    /**
     * @generated from protobuf field: string app_entitlement_user_binding = 5
     */
    appEntitlementUserBinding: string;
    /**
     * @generated from protobuf field: string user_path = 6
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchResponse
 */
export interface AccessReviewEntitlementPreviewServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewEntitlementPreviewView list = 1
     */
    list: AccessReviewEntitlementPreviewView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewRef
 */
export interface AccessReviewRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplate
 */
export interface AccessReviewTemplate {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string policy_id = 2
     */
    policyId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Duration access_review_duration = 6
     */
    accessReviewDuration?: Duration;
    /**
     * @generated from protobuf field: string description = 7
     */
    description: string;
    /**
     * @generated from protobuf field: string display_name = 8
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewInclusionScope inclusion_scope = 9
     */
    inclusionScope?: AccessReviewInclusionScope;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.RecurrenceRule recurrence_rule = 10
     */
    recurrenceRule?: RecurrenceRule;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp next_scheduled_campaign_at = 11
     */
    nextScheduledCampaignAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NotificationConfig notification_config = 12
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: bool is_campaign_schedule_enabled = 13
     */
    isCampaignScheduleEnabled: boolean;
    /**
     * @generated from protobuf oneof: slack_channel_details
     */
    slackChannelDetails: {
        oneofKind: "slackChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannel slack_channel = 100
         */
        slackChannel: SlackChannel;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: int32 occurrences = 14
     */
    occurrences: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope = 15
     */
    scope?: AccessReviewScopeV2;
    /**
     * @generated from protobuf field: string review_instructions = 16
     */
    reviewInstructions: string;
    /**
     * @generated from protobuf field: bool use_policy_override = 17
     */
    usePolicyOverride: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewViewType default_view = 18
     */
    defaultView: AccessReviewViewType;
    /**
     * auto generate report when campaign is closed
     *
     * @generated from protobuf field: bool auto_generate_report = 19
     */
    autoGenerateReport: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeType scope_type = 20
     */
    scopeType: AccessReviewScopeType;
    /**
     * @generated from protobuf field: bool exempt_certified_access_conflicts = 21
     */
    exemptCertifiedAccessConflicts: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewSignatureConfig signature_config = 22
     */
    signatureConfig?: ReviewSignatureConfig;
    /**
     * Auto-start configuration
     * next_scheduled_campaign_at will be used as the scheduled start date
     *
     * @generated from protobuf field: bool auto_start_campaign = 23
     */
    autoStartCampaign: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccuracyIssueAction accuracy_issue_action = 24
     */
    accuracyIssueAction: AccuracyIssueAction;
    /**
     * Auto-close configuration
     * start date and access_review_duration will be used to calculate the scheduled close date
     *
     * @generated from protobuf field: bool auto_close_campaign = 25
     */
    autoCloseCampaign: boolean;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.CloseDecision auto_close_decision = 26
     */
    autoCloseDecision: CloseDecision;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.RecurrenceRule
 */
export interface RecurrenceRule {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.RecurrenceRule.Frequency frequency = 1
     */
    frequency: RecurrenceRule_Frequency; // Frequency of the recurrence (daily, weekly, etc.)
    /**
     * @generated from protobuf field: int32 interval = 2
     */
    interval: number; // Number of time units between occurrences
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 3
     */
    startDate?: Timestamp; // Start date of the recurrence in ISO 8601 format (e.g., "2024-01-01")
    /**
     * @generated from protobuf oneof: end_condition
     */
    endCondition: {
        oneofKind: "endDate";
        /**
         * @generated from protobuf field: google.protobuf.Timestamp end_date = 4
         */
        endDate: Timestamp; // End date of the recurrence in ISO 8601 format (e.g., "2025-01-01")
    } | {
        oneofKind: "occurrences";
        /**
         * @generated from protobuf field: int32 occurrences = 5
         */
        occurrences: number; // Total number of occurrences
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.RecurrenceRule.Frequency
 */
export enum RecurrenceRule_Frequency {
    /**
     * @generated from protobuf enum value: FREQUENCY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: FREQUENCY_NONE = 1;
     */
    NONE = 1,
    /**
     * @generated from protobuf enum value: FREQUENCY_DAILY = 2;
     */
    DAILY = 2,
    /**
     * @generated from protobuf enum value: FREQUENCY_WEEKLY = 3;
     */
    WEEKLY = 3,
    /**
     * @generated from protobuf enum value: FREQUENCY_MONTHLY = 4;
     */
    MONTHLY = 4,
    /**
     * @generated from protobuf enum value: FREQUENCY_YEARLY = 5;
     */
    YEARLY = 5
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateRequest
 */
export interface AccessReviewTemplateServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Duration access_review_duration = 3
     */
    accessReviewDuration?: Duration;
    /**
     * @generated from protobuf field: string policy_id = 4
     */
    policyId: string;
    /**
     * @generated from protobuf field: repeated string owner_ids = 5
     */
    ownerIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.NotificationConfig notification_config = 6
     */
    notificationConfig?: NotificationConfig;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeType scope_type = 7
     */
    scopeType: AccessReviewScopeType;
    /**
     * The scope configuration for the access review template. When set, this allows configuring
     * the template scope at creation time instead of requiring a separate update.
     *
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope = 8
     */
    scope?: AccessReviewScopeV2;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateResponse
 */
export interface AccessReviewTemplateServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1
     */
    accessReviewTemplate?: AccessReviewTemplate;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteRequest
 */
export interface AccessReviewTemplateServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteResponse
 */
export interface AccessReviewTemplateServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListRequest
 */
export interface AccessReviewTemplateServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListResponse
 */
export interface AccessReviewTemplateServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplate list = 1
     */
    list: AccessReviewTemplate[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchRequest
 */
export interface AccessReviewTemplateServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.search.v1.SortOptions sort_options = 4
     */
    sortOptions?: SortOptions;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateRef refs = 5
     */
    refs: AccessReviewTemplateRef[];
    /**
     * Search for access review templates that use any of these policies.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 6
     */
    policyRefs: PolicyRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchResponse
 */
export interface AccessReviewTemplateServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplate list = 1
     */
    list: AccessReviewTemplate[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceGetRequest
 */
export interface AccessReviewTemplateServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceGetResponse
 */
export interface AccessReviewTemplateServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1
     */
    accessReviewTemplate?: AccessReviewTemplate;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersRequest
 */
export interface AccessReviewTemplateServiceListOwnersRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersResponse
 */
export interface AccessReviewTemplateServiceListOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersRequest
 */
export interface AccessReviewTemplateServiceSearchOwnersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateOwnerRef refs = 4
     */
    refs: AccessReviewTemplateOwnerRef[];
    /**
     * @generated from protobuf field: repeated string user_ids = 5
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView
 */
export interface AccessReviewTemplateServiceSearchOwnerView {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1
     */
    user?: User;
    /**
     * @generated from protobuf field: string access_review_template_id = 2
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersResponse
 */
export interface AccessReviewTemplateServiceSearchOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView list = 1
     */
    list: AccessReviewTemplateServiceSearchOwnerView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateRequest
 */
export interface AccessReviewTemplateServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1
     */
    accessReviewTemplate?: AccessReviewTemplate;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateResponse
 */
export interface AccessReviewTemplateServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1
     */
    accessReviewTemplate?: AccessReviewTemplate;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersRequest
 */
export interface AccessReviewTemplateServiceSetOwnersRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: repeated string owner_ids = 2
     */
    ownerIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersResponse
 */
export interface AccessReviewTemplateServiceSetOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsRequest
 */
export interface AccessReviewTemplateServiceListAccessReviewsRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsResponse
 */
export interface AccessReviewTemplateServiceListAccessReviewsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewView list = 1
     */
    list: AccessReviewView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateRef
 */
export interface AccessReviewTemplateRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateOwnerRef
 */
export interface AccessReviewTemplateOwnerRef {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 2
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest
 */
export interface AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse
 */
export interface AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem
 */
export interface AccessReviewTemplateAppResourceRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource item = 1
     */
    item?: AppResource;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView entitlements = 2
     */
    entitlements: AccessReviewTemplateAppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView
 */
export interface AccessReviewTemplateAppEntitlementView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1
     */
    appEntitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * @generated from protobuf field: string policy_path = 3
     */
    policyPath: string;
    /**
     * @generated from protobuf field: string app_resource_type_path = 4
     */
    appResourceTypePath: string;
    /**
     * @generated from protobuf field: string app_resource_path = 5
     */
    appResourcePath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewScopeV2
 */
export interface AccessReviewScopeV2 {
    /**
     * @generated from protobuf oneof: apps_and_resources_scope
     */
    appsAndResourcesScope: {
        oneofKind: "appAccess";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.ApplicationAccessScope app_access = 100
         */
        appAccess: ApplicationAccessScope;
    } | {
        oneofKind: "specificResources";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SpecificResourcesScope specific_resources = 101
         */
        specificResources: SpecificResourcesScope;
    } | {
        oneofKind: "appSelectionCriteria";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AppSelectionCriteriaScope app_selection_criteria = 102
         */
        appSelectionCriteria: AppSelectionCriteriaScope;
    } | {
        oneofKind: "resourceTypeSelections";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.ResourceTypeSelectionScope resource_type_selections = 103
         */
        resourceTypeSelections: ResourceTypeSelectionScope;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: users_scope
     */
    usersScope: {
        oneofKind: "allUsers";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AllUsersScope all_users = 200
         */
        allUsers: AllUsersScope;
    } | {
        oneofKind: "selectedUsers";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SelectedUsersScope selected_users = 201
         */
        selectedUsers: SelectedUsersScope;
    } | {
        oneofKind: "userCriteria";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.UserCriteriaScope user_criteria = 202
         */
        userCriteria: UserCriteriaScope;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.CelExpressionScope cel_expression = 203
         */
        celExpression: CelExpressionScope;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: accounts_scope
     */
    accountsScope: {
        oneofKind: "allAccounts";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AllAccountsScope all_accounts = 300
         */
        allAccounts: AllAccountsScope;
    } | {
        oneofKind: "accountCriteria";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AccountCriteriaScope account_criteria = 301
         */
        accountCriteria: AccountCriteriaScope;
    } | {
        oneofKind: "accountCelExpression";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.CelExpressionScope account_cel_expression = 302
         */
        accountCelExpression: CelExpressionScope;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: grants_scope
     */
    grantsScope: {
        oneofKind: "allGrants";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AllGrantsScope all_grants = 400
         */
        allGrants: AllGrantsScope;
    } | {
        oneofKind: "grantsByCriteria";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.GrantsByCriteriaScope grants_by_criteria = 401
         */
        grantsByCriteria: GrantsByCriteriaScope;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf oneof: access_conflicts_scope
     */
    accessConflictsScope: {
        oneofKind: "allAccessConflicts";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.AllAccessConflictsScope all_access_conflicts = 500
         */
        allAccessConflicts: AllAccessConflictsScope;
    } | {
        oneofKind: "specificAccessConflicts";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SpecificAccessConflictsScope specific_access_conflicts = 501
         */
        specificAccessConflicts: SpecificAccessConflictsScope;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AllAccessConflictsScope
 */
export interface AllAccessConflictsScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SpecificAccessConflictsScope
 */
export interface SpecificAccessConflictsScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ApplicationAccessScope
 */
export interface ApplicationAccessScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SpecificResourcesScope
 */
export interface SpecificResourcesScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AppSelectionCriteriaScope
 */
export interface AppSelectionCriteriaScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ResourceTypeSelectionScope
 */
export interface ResourceTypeSelectionScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AllUsersScope
 */
export interface AllUsersScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SelectedUsersScope
 */
export interface SelectedUsersScope {
    /**
     * @generated from protobuf field: repeated string user_ids = 1
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.UserCriteriaScope
 */
export interface UserCriteriaScope {
    /**
     * @generated from protobuf field: repeated string manager_user_ids = 1
     */
    managerUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_status = 2
     */
    userStatus: UserStatus$[];
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.IncludedUserAttributeValues> multi_user_profile_attributes = 3
     */
    multiUserProfileAttributes: {
        [key: string]: IncludedUserAttributeValues;
    };
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef group_app_entitlements_ref = 4
     */
    groupAppEntitlementsRef: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.CelExpressionScope
 */
export interface CelExpressionScope {
    /**
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AllAccountsScope
 */
export interface AllAccountsScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccountCriteriaScope
 */
export interface AccountCriteriaScope {
    /**
     * @generated from protobuf field: bool no_account_owner = 1
     */
    noAccountOwner: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2
     */
    appUserStatuses: AppUserStatus[];
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AppUserType account_types = 3
     */
    accountTypes: AppUserType[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserDomain account_domain = 4
     */
    accountDomain: AppUserDomain;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AllGrantsScope
 */
export interface AllGrantsScope {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GrantsByCriteriaScope
 */
export interface GrantsByCriteriaScope {
    /**
     * @generated from protobuf oneof: criteria_filter
     */
    criteriaFilter: {
        oneofKind: "daysSinceAdded";
        /**
         * @generated from protobuf field: google.protobuf.Duration days_since_added = 100
         */
        daysSinceAdded: Duration;
    } | {
        oneofKind: "daysSinceReviewed";
        /**
         * @generated from protobuf field: google.protobuf.Duration days_since_reviewed = 101
         */
        daysSinceReviewed: Duration;
    } | {
        oneofKind: "grantsAddedBetween";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.GrantsAddedBetween grants_added_between = 103
         */
        grantsAddedBetween: GrantsAddedBetween;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.GrantFilterType type_filter = 1
     */
    typeFilter: GrantFilterType;
    /**
     * @generated from protobuf field: google.protobuf.Duration days_since_last_used = 2
     */
    daysSinceLastUsed?: Duration;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.GrantSourceFilter source_filter = 3
     */
    sourceFilter: GrantSourceFilter;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.GrantAccessProfileFilter access_profile_filter = 4
     */
    accessProfileFilter?: GrantAccessProfileFilter;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GrantsAddedBetween
 */
export interface GrantsAddedBetween {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 1
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 2
     */
    endDate?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GrantAccessProfileFilter
 */
export interface GrantAccessProfileFilter {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessProfileFilterType filter_type = 1
     */
    filterType: AccessProfileFilterType;
    /**
     * Access profile IDs to EXCLUDE from the campaign
     * Used when filter_type = EXCLUDE_SPECIFIC
     * Max 32 profile IDs
     *
     * @generated from protobuf field: repeated string excluded_access_profile_ids = 2
     */
    excludedAccessProfileIds: string[];
    /**
     * Access profile IDs to INCLUDE in the campaign
     * Used when filter_type = INCLUDE_SPECIFIC
     * Max 32 profile IDs
     *
     * @generated from protobuf field: repeated string included_access_profile_ids = 3
     */
    includedAccessProfileIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSource
 */
export interface AccessReviewConnectorSource {
    /**
     * @generated from protobuf field: string tenant_id = 1
     */
    tenantId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string access_review_id = 4
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sync_start_at = 8
     */
    syncStartAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sync_end_at = 9
     */
    syncEndAt?: Timestamp;
    /**
     * @generated from protobuf field: int64 connector_version = 10
     */
    connectorVersion: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ConnectorType connector_type = 11
     */
    connectorType: ConnectorType;
    /**
     * contains the id of the sync artifact
     *
     * @generated from protobuf field: string connector_sync_artifact = 12
     */
    connectorSyncArtifact: string;
    /**
     * @generated from protobuf field: map<string, int64> stats = 13
     */
    stats: {
        [key: string]: number;
    };
    /**
     * @generated from protobuf field: google.protobuf.Timestamp frozen_at = 14
     */
    frozenAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceView
 */
export interface AccessReviewConnectorSourceView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSource access_review_connector_source = 1
     */
    accessReviewConnectorSource?: AccessReviewConnectorSource;
    /**
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * @generated from protobuf field: string connector_path = 3
     */
    connectorPath: string;
    /**
     * @generated from protobuf field: string sync_lifecycle_path = 4
     */
    syncLifecyclePath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask
 */
export interface AccessReviewConnectorSourceExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef
 */
export interface AccessReviewTemplateResourceRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 2
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchRequest
 */
export interface AccessReviewTemplateResourceRollupSearchRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AccessReviewTemplateAppEntitlementExpandMask;
    /**
     * @generated from protobuf field: string query = 5
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef refs = 6
     */
    refs: AccessReviewTemplateResourceRollupRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchResponse
 */
export interface AccessReviewTemplateResourceRollupSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem list = 1
     */
    list: AccessReviewTemplateAppResourceRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem
 */
export interface AccessReviewTemplateResourceTypeRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceTypeView item = 1
     */
    item?: AppResourceTypeView;
    /**
     * @generated from protobuf field: int64 resource_count = 2
     */
    resourceCount: number;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef
 */
export interface AccessReviewTemplateResourceTypeRollupRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 2
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchRequest
 */
export interface AccessReviewTemplateSearchResourceTypeRollupSearchRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef refs = 5
     */
    refs: AccessReviewTemplateResourceTypeRollupRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchResponse
 */
export interface AccessReviewTemplateSearchResourceTypeRollupSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem list = 1
     */
    list: AccessReviewTemplateResourceTypeRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: string access_review_template_id = 3
     */
    accessReviewTemplateId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ValidateScopeRequest
 */
export interface ValidateScopeRequest {
    /**
     * @generated from protobuf field: string campaign_id = 1
     */
    campaignId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ValidateScopeRequest.CampaignType campaign_type = 2
     */
    campaignType: ValidateScopeRequest_CampaignType;
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ValidateScopeRequest.CampaignType
 */
export enum ValidateScopeRequest_CampaignType {
    /**
     * @generated from protobuf enum value: CAMPAIGN_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CAMPAIGN_TYPE_ACCESS_REVIEW = 1;
     */
    ACCESS_REVIEW = 1,
    /**
     * @generated from protobuf enum value: CAMPAIGN_TYPE_ACCESS_REVIEW_TEMPLATE = 2;
     */
    ACCESS_REVIEW_TEMPLATE = 2
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceListRequest
 */
export interface AccessReviewConnectorSourceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 3
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 4
     */
    expandMask?: AccessReviewConnectorSourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceListResponse
 */
export interface AccessReviewConnectorSourceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1
     */
    list: AccessReviewConnectorSourceView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceSearchRequest
 */
export interface AccessReviewConnectorSourceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 4
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 5
     */
    expandMask?: AccessReviewConnectorSourceExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceRef refs = 6
     */
    refs: AccessReviewConnectorSourceRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceSearchResponse
 */
export interface AccessReviewConnectorSourceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1
     */
    list: AccessReviewConnectorSourceView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchRequest
 */
export interface AccessReviewConnectorSourceOutdatedSearchRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_review_id = 4
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 5
     */
    expandMask?: AccessReviewConnectorSourceExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceRef refs = 6
     */
    refs: AccessReviewConnectorSourceRef[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchResponse
 */
export interface AccessReviewConnectorSourceOutdatedSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1
     */
    list: AccessReviewConnectorSourceView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * -------- Access Review By Access Conflicts
 *
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask
 */
export interface AccessReviewSetupAccessConflictExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflictView
 */
export interface AccessReviewSetupAccessConflictView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSetupAccessConflict access_conflict = 1
     */
    accessConflict?: AccessReviewSetupAccessConflict;
    /**
     * @generated from protobuf field: string access_conflict_path = 2
     */
    accessConflictPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflict
 */
export interface AccessReviewSetupAccessConflict {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 2
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListRequest
 */
export interface AccessReviewByAccessConflictsServiceListRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask expand_mask = 4
     */
    expandMask?: AccessReviewSetupAccessConflictExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListResponse
 */
export interface AccessReviewByAccessConflictsServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewSetupAccessConflictView list = 1
     */
    list: AccessReviewSetupAccessConflictView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictRequest
 */
export interface AccessReviewSetScopeByAccessConflictRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: repeated string access_conflict_monitor_ids = 2
     */
    accessConflictMonitorIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 3
     */
    scopeV2?: AccessReviewScopeV2;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictResponse
 */
export interface AccessReviewSetScopeByAccessConflictResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView
 */
export interface AccessReviewTemplateSetupAccessConflictView {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict access_conflict = 1
     */
    accessConflict?: AccessReviewTemplateSetupAccessConflict;
    /**
     * @generated from protobuf field: string access_conflict_path = 2
     */
    accessConflictPath: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict
 */
export interface AccessReviewTemplateSetupAccessConflict {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: string conflict_monitor_id = 2
     */
    conflictMonitorId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListRequest
 */
export interface AccessReviewTemplateByAccessConflictsServiceListRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask expand_mask = 4
     */
    expandMask?: AccessReviewSetupAccessConflictExpandMask;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListResponse
 */
export interface AccessReviewTemplateByAccessConflictsServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView list = 1
     */
    list: AccessReviewTemplateSetupAccessConflictView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictRequest
 */
export interface AccessReviewTemplateSetScopeByAccessConflictRequest {
    /**
     * @generated from protobuf field: string access_review_template_id = 1
     */
    accessReviewTemplateId: string;
    /**
     * @generated from protobuf field: repeated string access_conflict_monitor_ids = 2
     */
    accessConflictMonitorIds: string[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 3
     */
    scopeV2?: AccessReviewScopeV2;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictResponse
 */
export interface AccessReviewTemplateSetScopeByAccessConflictResponse {
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessReviewState
 */
export enum AccessReviewState {
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_OPEN = 1;
     */
    OPEN = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_CLOSED = 2;
     */
    CLOSED = 2,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_PENDING = 3;
     */
    PENDING = 3,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_REVIEW = 4;
     */
    REVIEW = 4,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_PREPARING = 5;
     */
    PREPARING = 5,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_STARTING = 6;
     */
    STARTING = 6,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_DRAFT = 7;
     */
    DRAFT = 7,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_DELETING = 8;
     */
    DELETING = 8,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_DELETED = 9;
     */
    DELETED = 9,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_RESETTING_POLICIES = 10;
     */
    RESETTING_POLICIES = 10,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_COPYING_SETUP_ENTITLEMENTS = 11;
     */
    COPYING_SETUP_ENTITLEMENTS = 11,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_STATE_COPYING_RESOURCE_TYPE_SELECTIONS = 12;
     */
    COPYING_RESOURCE_TYPE_SELECTIONS = 12
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessReviewViewType
 */
export enum AccessReviewViewType {
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_VIEW_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_VIEW_TYPE_BY_APP = 1;
     */
    BY_APP = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_VIEW_TYPE_BY_USER = 2;
     */
    BY_USER = 2,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_VIEW_TYPE_UNSTRUCTURED = 3;
     */
    UNSTRUCTURED = 3
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessReviewScopeType
 */
export enum AccessReviewScopeType {
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SCOPE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SCOPE_TYPE_BY_ENTITLEMENTS = 1;
     */
    BY_ENTITLEMENTS = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SCOPE_TYPE_BY_ACCESS_CONFLICTS = 2;
     */
    BY_ACCESS_CONFLICTS = 2
}
/**
 * Action to take when accuracy issues are detected
 *
 * @generated from protobuf enum c1.api.accessreview.v1.AccuracyIssueAction
 */
export enum AccuracyIssueAction {
    /**
     * @generated from protobuf enum value: ACCURACY_ISSUE_ACTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Start campaign despite accuracy issues
     *
     * @generated from protobuf enum value: ACCURACY_ISSUE_ACTION_CONTINUE = 1;
     */
    CONTINUE = 1,
    /**
     * Wait until accuracy issues are resolved
     *
     * @generated from protobuf enum value: ACCURACY_ISSUE_ACTION_WAIT = 2;
     */
    WAIT = 2
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessReviewSelectionState
 */
export enum AccessReviewSelectionState {
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_CREATED = 1;
     */
    CERTIFICATION_CREATED = 1,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_OPEN = 2;
     */
    CERTIFICATION_OPEN = 2,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_CERTIFIED = 3;
     */
    CERTIFICATION_CERTIFIED = 3,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_REJECTED = 4;
     */
    CERTIFICATION_REJECTED = 4,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_PAST_DUE = 5;
     */
    CERTIFICATION_PAST_DUE = 5,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_RESOLUTION_RESOLVED = 6;
     */
    RESOLUTION_RESOLVED = 6,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_RESOLUTION_DECLINED = 7;
     */
    RESOLUTION_DECLINED = 7,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_CANCELLED = 8;
     */
    CERTIFICATION_CANCELLED = 8,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_ERROR = 9;
     */
    CERTIFICATION_ERROR = 9,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_SKIPPED = 10;
     */
    CERTIFICATION_SKIPPED = 10,
    /**
     * @generated from protobuf enum value: ACCESS_REVIEW_SELECTION_STATE_CERTIFICATION_CANCELLED_BEFORE_CAMPAIGN_START = 11;
     */
    CERTIFICATION_CANCELLED_BEFORE_CAMPAIGN_START = 11
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReportState
 */
export enum ReportState {
    /**
     * @generated from protobuf enum value: REPORT_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REPORT_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: REPORT_STATE_OK = 2;
     */
    OK = 2,
    /**
     * @generated from protobuf enum value: REPORT_STATE_ERROR = 3;
     */
    ERROR = 3
}
/**
 * from c1.api.app.v1.AppUserStatus.Status
 *
 * @generated from protobuf enum c1.api.accessreview.v1.AppUserStatus
 */
export enum AppUserStatus {
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_ENABLED = 1;
     */
    ENABLED = 1,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_DISABLED = 2;
     */
    DISABLED = 2,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_DELETED = 3;
     */
    DELETED = 3
}
/**
 * from c1.api.app.v1.AppUserType
 *
 * @generated from protobuf enum c1.api.accessreview.v1.AppUserType
 */
export enum AppUserType {
    /**
     * @generated from protobuf enum value: APP_USER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_USER_TYPE_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: APP_USER_TYPE_SERVICE_ACCOUNT = 2;
     */
    SERVICE_ACCOUNT = 2,
    /**
     * @generated from protobuf enum value: APP_USER_TYPE_SYSTEM_ACCOUNT = 3;
     */
    SYSTEM_ACCOUNT = 3
}
/**
 * from c1.api.User.v1.UserStatus
 *
 * @generated from protobuf enum c1.api.accessreview.v1.UserStatus
 */
export enum UserStatus {
    /**
     * @generated from protobuf enum value: USER_UNKNOWN = 0;
     */
    USER_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: USER_ENABLED = 1;
     */
    USER_ENABLED = 1,
    /**
     * @generated from protobuf enum value: USER_DISABLED = 2;
     */
    USER_DISABLED = 2,
    /**
     * @generated from protobuf enum value: USER_DELETED = 3;
     */
    USER_DELETED = 3
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.GrantFilterType
 */
export enum GrantFilterType {
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_PERMANENT = 1;
     */
    PERMANENT = 1,
    /**
     * @generated from protobuf enum value: GRANT_FILTER_TYPE_TEMPORARY = 2;
     */
    TEMPORARY = 2
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.GrantSourceFilter
 */
export enum GrantSourceFilter {
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_DIRECT = 1;
     */
    DIRECT = 1,
    /**
     * @generated from protobuf enum value: GRANT_SOURCE_FILTER_INHERITED = 2;
     */
    INHERITED = 2
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.AccessProfileFilterType
 */
export enum AccessProfileFilterType {
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_INCLUDE_ALL = 1;
     */
    INCLUDE_ALL = 1,
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_EXCLUDE_ALL = 2;
     */
    EXCLUDE_ALL = 2,
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_EXCLUDE_SPECIFIC = 3;
     */
    EXCLUDE_SPECIFIC = 3,
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_FILTER_TYPE_INCLUDE_SPECIFIC = 4;
     */
    INCLUDE_SPECIFIC = 4
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ConnectorType
 */
export enum ConnectorType {
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_FILE = 1;
     */
    FILE = 1,
    /**
     * @generated from protobuf enum value: CONNECTOR_TYPE_STANDARD = 2;
     */
    STANDARD = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SingleAppSetup$Type extends MessageType<SingleAppSetup> {
    constructor() {
        super("c1.api.accessreview.v1.SingleAppSetup", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SingleAppSetup>): SingleAppSetup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<SingleAppSetup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SingleAppSetup): SingleAppSetup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SingleAppSetup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SingleAppSetup
 */
export const SingleAppSetup = new SingleAppSetup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiAppEntitlement$Type extends MessageType<MultiAppEntitlement> {
    constructor() {
        super("c1.api.accessreview.v1.MultiAppEntitlement", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<MultiAppEntitlement>): MultiAppEntitlement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.entitlementIds = [];
        if (value !== undefined)
            reflectionMergePartial<MultiAppEntitlement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MultiAppEntitlement): MultiAppEntitlement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* repeated string entitlement_ids */ 2:
                    message.entitlementIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MultiAppEntitlement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* repeated string entitlement_ids = 2; */
        for (let i = 0; i < message.entitlementIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.MultiAppEntitlement
 */
export const MultiAppEntitlement = new MultiAppEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementToDetails$Type extends MessageType<EntitlementToDetails> {
    constructor() {
        super("c1.api.accessreview.v1.EntitlementToDetails", [
            { no: 1, name: "entitlement_details", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => CampaignEntitlementDetails } }
        ]);
    }
    create(value?: PartialMessage<EntitlementToDetails>): EntitlementToDetails {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlementDetails = {};
        if (value !== undefined)
            reflectionMergePartial<EntitlementToDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementToDetails): EntitlementToDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, c1.api.accessreview.v1.CampaignEntitlementDetails> entitlement_details */ 1:
                    this.binaryReadMap1(message.entitlementDetails, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: EntitlementToDetails["entitlementDetails"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof EntitlementToDetails["entitlementDetails"] | undefined, val: EntitlementToDetails["entitlementDetails"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = CampaignEntitlementDetails.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accessreview.v1.EntitlementToDetails.entitlement_details");
            }
        }
        map[key ?? ""] = val ?? CampaignEntitlementDetails.create();
    }
    internalBinaryWrite(message: EntitlementToDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, c1.api.accessreview.v1.CampaignEntitlementDetails> entitlement_details = 1; */
        for (let k of globalThis.Object.keys(message.entitlementDetails)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            CampaignEntitlementDetails.internalBinaryWrite(message.entitlementDetails[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.EntitlementToDetails
 */
export const EntitlementToDetails = new EntitlementToDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CampaignEntitlementDetails$Type extends MessageType<CampaignEntitlementDetails> {
    constructor() {
        super("c1.api.accessreview.v1.CampaignEntitlementDetails", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CampaignEntitlementDetails>): CampaignEntitlementDetails {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.entitlementId = "";
        message.policyId = "";
        if (value !== undefined)
            reflectionMergePartial<CampaignEntitlementDetails>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CampaignEntitlementDetails): CampaignEntitlementDetails {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 2:
                    message.entitlementId = reader.string();
                    break;
                case /* string policy_id */ 3:
                    message.policyId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CampaignEntitlementDetails, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 2; */
        if (message.entitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementId);
        /* string policy_id = 3; */
        if (message.policyId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.policyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.CampaignEntitlementDetails
 */
export const CampaignEntitlementDetails = new CampaignEntitlementDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiAppSetup$Type extends MessageType<MultiAppSetup> {
    constructor() {
        super("c1.api.accessreview.v1.MultiAppSetup", [
            { no: 1, name: "app_entitlements", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => MultiAppEntitlement } },
            { no: 2, name: "app_entitlement_details", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => EntitlementToDetails } }
        ]);
    }
    create(value?: PartialMessage<MultiAppSetup>): MultiAppSetup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlements = {};
        message.appEntitlementDetails = {};
        if (value !== undefined)
            reflectionMergePartial<MultiAppSetup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MultiAppSetup): MultiAppSetup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, c1.api.accessreview.v1.MultiAppEntitlement> app_entitlements */ 1:
                    this.binaryReadMap1(message.appEntitlements, reader, options);
                    break;
                case /* map<string, c1.api.accessreview.v1.EntitlementToDetails> app_entitlement_details */ 2:
                    this.binaryReadMap2(message.appEntitlementDetails, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: MultiAppSetup["appEntitlements"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof MultiAppSetup["appEntitlements"] | undefined, val: MultiAppSetup["appEntitlements"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = MultiAppEntitlement.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accessreview.v1.MultiAppSetup.app_entitlements");
            }
        }
        map[key ?? ""] = val ?? MultiAppEntitlement.create();
    }
    private binaryReadMap2(map: MultiAppSetup["appEntitlementDetails"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof MultiAppSetup["appEntitlementDetails"] | undefined, val: MultiAppSetup["appEntitlementDetails"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = EntitlementToDetails.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accessreview.v1.MultiAppSetup.app_entitlement_details");
            }
        }
        map[key ?? ""] = val ?? EntitlementToDetails.create();
    }
    internalBinaryWrite(message: MultiAppSetup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, c1.api.accessreview.v1.MultiAppEntitlement> app_entitlements = 1; */
        for (let k of globalThis.Object.keys(message.appEntitlements)) {
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            MultiAppEntitlement.internalBinaryWrite(message.appEntitlements[k], writer, options);
            writer.join().join();
        }
        /* map<string, c1.api.accessreview.v1.EntitlementToDetails> app_entitlement_details = 2; */
        for (let k of globalThis.Object.keys(message.appEntitlementDetails)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            EntitlementToDetails.internalBinaryWrite(message.appEntitlementDetails[k], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.MultiAppSetup
 */
export const MultiAppSetup = new MultiAppSetup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationConfig$Type extends MessageType<NotificationConfig> {
    constructor() {
        super("c1.api.accessreview.v1.NotificationConfig", [
            { no: 1, name: "send_reminders", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "send_close", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "send_kickoff", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<NotificationConfig>): NotificationConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sendReminders = false;
        message.sendClose = false;
        message.sendKickoff = false;
        if (value !== undefined)
            reflectionMergePartial<NotificationConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationConfig): NotificationConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool send_reminders */ 1:
                    message.sendReminders = reader.bool();
                    break;
                case /* bool send_close */ 2:
                    message.sendClose = reader.bool();
                    break;
                case /* bool send_kickoff */ 3:
                    message.sendKickoff = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool send_reminders = 1; */
        if (message.sendReminders !== false)
            writer.tag(1, WireType.Varint).bool(message.sendReminders);
        /* bool send_close = 2; */
        if (message.sendClose !== false)
            writer.tag(2, WireType.Varint).bool(message.sendClose);
        /* bool send_kickoff = 3; */
        if (message.sendKickoff !== false)
            writer.tag(3, WireType.Varint).bool(message.sendKickoff);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.NotificationConfig
 */
export const NotificationConfig = new NotificationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReview$Type extends MessageType<AccessReview> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReview", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "created_by_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewState", AccessReviewState, "ACCESS_REVIEW_STATE_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 8, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 9, name: "auto_resolve", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "completion_date", kind: "message", T: () => Timestamp },
            { no: 11, name: "closed_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "notification_config", kind: "message", T: () => NotificationConfig },
            { no: 13, name: "started_at", kind: "message", T: () => Timestamp },
            { no: 100, name: "single_app", kind: "message", oneof: "setupMetadata", T: () => SingleAppSetup },
            { no: 101, name: "multi_app", kind: "message", oneof: "setupMetadata", T: () => MultiAppSetup },
            { no: 102, name: "bindings", kind: "message", oneof: "setupMetadata", T: () => BindingObjectSetup },
            { no: 14, name: "exclusion_scope", kind: "message", T: () => AccessReviewExclusionScope },
            { no: 15, name: "scope", kind: "message", T: () => AccessReviewScope },
            { no: 16, name: "inclusion_scope", kind: "message", T: () => AccessReviewInclusionScope },
            { no: 17, name: "expected_ticket_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 19, name: "scoping_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 20, name: "scope_v2", kind: "message", T: () => AccessReviewScopeV2 },
            { no: 21, name: "connector_sources_frozen_at", kind: "message", T: () => Timestamp },
            { no: 22, name: "has_accuracy_support", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "review_instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 24, name: "use_policy_override", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 25, name: "default_view", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewViewType", AccessReviewViewType, "ACCESS_REVIEW_VIEW_TYPE_"] },
            { no: 26, name: "auto_generate_report", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "scope_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewScopeType", AccessReviewScopeType, "ACCESS_REVIEW_SCOPE_TYPE_"] },
            { no: 28, name: "exempt_certified_access_conflicts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "signature_config", kind: "message", T: () => ReviewSignatureConfig },
            { no: 30, name: "auto_start_campaign", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "scheduled_start_date", kind: "message", T: () => Timestamp },
            { no: 32, name: "accuracy_issue_action", kind: "enum", T: () => ["c1.api.accessreview.v1.AccuracyIssueAction", AccuracyIssueAction, "ACCURACY_ISSUE_ACTION_"] },
            { no: 33, name: "auto_close_campaign", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 34, name: "auto_close_decision", kind: "enum", T: () => ["c1.api.accessreview.v1.CloseDecision", CloseDecision, "CLOSE_DECISION_"] }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access Review" } }] } });
    }
    create(value?: PartialMessage<AccessReview>): AccessReview {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.createdById = "";
        message.state = 0;
        message.description = "";
        message.policyId = "";
        message.autoResolve = false;
        message.setupMetadata = { oneofKind: undefined };
        message.expectedTicketCount = 0;
        message.accessReviewTemplateId = "";
        message.scopingVersion = 0;
        message.hasAccuracySupport = false;
        message.reviewInstructions = "";
        message.usePolicyOverride = false;
        message.defaultView = 0;
        message.autoGenerateReport = false;
        message.scopeType = 0;
        message.exemptCertifiedAccessConflicts = false;
        message.autoStartCampaign = false;
        message.accuracyIssueAction = 0;
        message.autoCloseCampaign = false;
        message.autoCloseDecision = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReview>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReview): AccessReview {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string created_by_id */ 3:
                    message.createdById = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewState state */ 4:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* string policy_id */ 8:
                    message.policyId = reader.string();
                    break;
                case /* bool auto_resolve */ 9:
                    message.autoResolve = reader.bool();
                    break;
                case /* google.protobuf.Timestamp completion_date */ 10:
                    message.completionDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completionDate);
                    break;
                case /* google.protobuf.Timestamp closed_at */ 11:
                    message.closedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.closedAt);
                    break;
                case /* c1.api.accessreview.v1.NotificationConfig notification_config */ 12:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                case /* google.protobuf.Timestamp started_at */ 13:
                    message.startedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startedAt);
                    break;
                case /* c1.api.accessreview.v1.SingleAppSetup single_app */ 100:
                    message.setupMetadata = {
                        oneofKind: "singleApp",
                        singleApp: SingleAppSetup.internalBinaryRead(reader, reader.uint32(), options, (message.setupMetadata as any).singleApp)
                    };
                    break;
                case /* c1.api.accessreview.v1.MultiAppSetup multi_app */ 101:
                    message.setupMetadata = {
                        oneofKind: "multiApp",
                        multiApp: MultiAppSetup.internalBinaryRead(reader, reader.uint32(), options, (message.setupMetadata as any).multiApp)
                    };
                    break;
                case /* c1.api.accessreview.v1.BindingObjectSetup bindings */ 102:
                    message.setupMetadata = {
                        oneofKind: "bindings",
                        bindings: BindingObjectSetup.internalBinaryRead(reader, reader.uint32(), options, (message.setupMetadata as any).bindings)
                    };
                    break;
                case /* c1.api.accessreview.v1.AccessReviewExclusionScope exclusion_scope */ 14:
                    message.exclusionScope = AccessReviewExclusionScope.internalBinaryRead(reader, reader.uint32(), options, message.exclusionScope);
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScope scope */ 15:
                    message.scope = AccessReviewScope.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* c1.api.accessreview.v1.AccessReviewInclusionScope inclusion_scope */ 16:
                    message.inclusionScope = AccessReviewInclusionScope.internalBinaryRead(reader, reader.uint32(), options, message.inclusionScope);
                    break;
                case /* int32 expected_ticket_count */ 17:
                    message.expectedTicketCount = reader.int32();
                    break;
                case /* string access_review_template_id */ 18:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* int64 scoping_version */ 19:
                    message.scopingVersion = reader.int64().toNumber();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 */ 20:
                    message.scopeV2 = AccessReviewScopeV2.internalBinaryRead(reader, reader.uint32(), options, message.scopeV2);
                    break;
                case /* google.protobuf.Timestamp connector_sources_frozen_at */ 21:
                    message.connectorSourcesFrozenAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.connectorSourcesFrozenAt);
                    break;
                case /* bool has_accuracy_support */ 22:
                    message.hasAccuracySupport = reader.bool();
                    break;
                case /* string review_instructions */ 23:
                    message.reviewInstructions = reader.string();
                    break;
                case /* bool use_policy_override */ 24:
                    message.usePolicyOverride = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewViewType default_view */ 25:
                    message.defaultView = reader.int32();
                    break;
                case /* bool auto_generate_report */ 26:
                    message.autoGenerateReport = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeType scope_type */ 27:
                    message.scopeType = reader.int32();
                    break;
                case /* bool exempt_certified_access_conflicts */ 28:
                    message.exemptCertifiedAccessConflicts = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.ReviewSignatureConfig signature_config */ 29:
                    message.signatureConfig = ReviewSignatureConfig.internalBinaryRead(reader, reader.uint32(), options, message.signatureConfig);
                    break;
                case /* bool auto_start_campaign */ 30:
                    message.autoStartCampaign = reader.bool();
                    break;
                case /* google.protobuf.Timestamp scheduled_start_date */ 31:
                    message.scheduledStartDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.scheduledStartDate);
                    break;
                case /* c1.api.accessreview.v1.AccuracyIssueAction accuracy_issue_action */ 32:
                    message.accuracyIssueAction = reader.int32();
                    break;
                case /* bool auto_close_campaign */ 33:
                    message.autoCloseCampaign = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.CloseDecision auto_close_decision */ 34:
                    message.autoCloseDecision = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReview, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string created_by_id = 3; */
        if (message.createdById !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.createdById);
        /* c1.api.accessreview.v1.AccessReviewState state = 4; */
        if (message.state !== 0)
            writer.tag(4, WireType.Varint).int32(message.state);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* string policy_id = 8; */
        if (message.policyId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.policyId);
        /* bool auto_resolve = 9; */
        if (message.autoResolve !== false)
            writer.tag(9, WireType.Varint).bool(message.autoResolve);
        /* google.protobuf.Timestamp completion_date = 10; */
        if (message.completionDate)
            Timestamp.internalBinaryWrite(message.completionDate, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp closed_at = 11; */
        if (message.closedAt)
            Timestamp.internalBinaryWrite(message.closedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.NotificationConfig notification_config = 12; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp started_at = 13; */
        if (message.startedAt)
            Timestamp.internalBinaryWrite(message.startedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewExclusionScope exclusion_scope = 14; */
        if (message.exclusionScope)
            AccessReviewExclusionScope.internalBinaryWrite(message.exclusionScope, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewScope scope = 15; */
        if (message.scope)
            AccessReviewScope.internalBinaryWrite(message.scope, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewInclusionScope inclusion_scope = 16; */
        if (message.inclusionScope)
            AccessReviewInclusionScope.internalBinaryWrite(message.inclusionScope, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* int32 expected_ticket_count = 17; */
        if (message.expectedTicketCount !== 0)
            writer.tag(17, WireType.Varint).int32(message.expectedTicketCount);
        /* string access_review_template_id = 18; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* int64 scoping_version = 19; */
        if (message.scopingVersion !== 0)
            writer.tag(19, WireType.Varint).int64(message.scopingVersion);
        /* c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 20; */
        if (message.scopeV2)
            AccessReviewScopeV2.internalBinaryWrite(message.scopeV2, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp connector_sources_frozen_at = 21; */
        if (message.connectorSourcesFrozenAt)
            Timestamp.internalBinaryWrite(message.connectorSourcesFrozenAt, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* bool has_accuracy_support = 22; */
        if (message.hasAccuracySupport !== false)
            writer.tag(22, WireType.Varint).bool(message.hasAccuracySupport);
        /* string review_instructions = 23; */
        if (message.reviewInstructions !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.reviewInstructions);
        /* bool use_policy_override = 24; */
        if (message.usePolicyOverride !== false)
            writer.tag(24, WireType.Varint).bool(message.usePolicyOverride);
        /* c1.api.accessreview.v1.AccessReviewViewType default_view = 25; */
        if (message.defaultView !== 0)
            writer.tag(25, WireType.Varint).int32(message.defaultView);
        /* bool auto_generate_report = 26; */
        if (message.autoGenerateReport !== false)
            writer.tag(26, WireType.Varint).bool(message.autoGenerateReport);
        /* c1.api.accessreview.v1.AccessReviewScopeType scope_type = 27; */
        if (message.scopeType !== 0)
            writer.tag(27, WireType.Varint).int32(message.scopeType);
        /* bool exempt_certified_access_conflicts = 28; */
        if (message.exemptCertifiedAccessConflicts !== false)
            writer.tag(28, WireType.Varint).bool(message.exemptCertifiedAccessConflicts);
        /* c1.api.accessreview.v1.ReviewSignatureConfig signature_config = 29; */
        if (message.signatureConfig)
            ReviewSignatureConfig.internalBinaryWrite(message.signatureConfig, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* bool auto_start_campaign = 30; */
        if (message.autoStartCampaign !== false)
            writer.tag(30, WireType.Varint).bool(message.autoStartCampaign);
        /* google.protobuf.Timestamp scheduled_start_date = 31; */
        if (message.scheduledStartDate)
            Timestamp.internalBinaryWrite(message.scheduledStartDate, writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccuracyIssueAction accuracy_issue_action = 32; */
        if (message.accuracyIssueAction !== 0)
            writer.tag(32, WireType.Varint).int32(message.accuracyIssueAction);
        /* bool auto_close_campaign = 33; */
        if (message.autoCloseCampaign !== false)
            writer.tag(33, WireType.Varint).bool(message.autoCloseCampaign);
        /* c1.api.accessreview.v1.CloseDecision auto_close_decision = 34; */
        if (message.autoCloseDecision !== 0)
            writer.tag(34, WireType.Varint).int32(message.autoCloseDecision);
        /* c1.api.accessreview.v1.SingleAppSetup single_app = 100; */
        if (message.setupMetadata.oneofKind === "singleApp")
            SingleAppSetup.internalBinaryWrite(message.setupMetadata.singleApp, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.MultiAppSetup multi_app = 101; */
        if (message.setupMetadata.oneofKind === "multiApp")
            MultiAppSetup.internalBinaryWrite(message.setupMetadata.multiApp, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.BindingObjectSetup bindings = 102; */
        if (message.setupMetadata.oneofKind === "bindings")
            BindingObjectSetup.internalBinaryWrite(message.setupMetadata.bindings, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReview
 */
export const AccessReview = new AccessReview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReviewSignatureConfig$Type extends MessageType<ReviewSignatureConfig> {
    constructor() {
        super("c1.api.accessreview.v1.ReviewSignatureConfig", [
            { no: 1, name: "require_signature", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "step_up_provider_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "meaning_of_signature", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "tsp_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ReviewSignatureConfig>): ReviewSignatureConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.requireSignature = false;
        message.stepUpProviderId = "";
        message.meaningOfSignature = "";
        message.tspUrl = "";
        if (value !== undefined)
            reflectionMergePartial<ReviewSignatureConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReviewSignatureConfig): ReviewSignatureConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool require_signature */ 1:
                    message.requireSignature = reader.bool();
                    break;
                case /* string step_up_provider_id */ 2:
                    message.stepUpProviderId = reader.string();
                    break;
                case /* string meaning_of_signature */ 3:
                    message.meaningOfSignature = reader.string();
                    break;
                case /* string tsp_url */ 4:
                    message.tspUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReviewSignatureConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool require_signature = 1; */
        if (message.requireSignature !== false)
            writer.tag(1, WireType.Varint).bool(message.requireSignature);
        /* string step_up_provider_id = 2; */
        if (message.stepUpProviderId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stepUpProviderId);
        /* string meaning_of_signature = 3; */
        if (message.meaningOfSignature !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.meaningOfSignature);
        /* string tsp_url = 4; */
        if (message.tspUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tspUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ReviewSignatureConfig
 */
export const ReviewSignatureConfig = new ReviewSignatureConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindingObjectSetup$Type extends MessageType<BindingObjectSetup> {
    constructor() {
        super("c1.api.accessreview.v1.BindingObjectSetup", []);
    }
    create(value?: PartialMessage<BindingObjectSetup>): BindingObjectSetup {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BindingObjectSetup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BindingObjectSetup): BindingObjectSetup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BindingObjectSetup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.BindingObjectSetup
 */
export const BindingObjectSetup = new BindingObjectSetup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewScope$Type extends MessageType<AccessReviewScope> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewScope", [
            { no: 1, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 2, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserStatus", AppUserStatus, "APP_USER_STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewScope>): AccessReviewScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserTypes = [];
        message.appUserStatuses = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewScope): AccessReviewScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AppUserType app_user_types */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserTypes.push(reader.int32());
                    else
                        message.appUserTypes.push(reader.int32());
                    break;
                case /* repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserStatuses.push(reader.int32());
                    else
                        message.appUserStatuses.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AppUserType app_user_types = 1; */
        if (message.appUserTypes.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserTypes.length; i++)
                writer.int32(message.appUserTypes[i]);
            writer.join();
        }
        /* repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2; */
        if (message.appUserStatuses.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserStatuses.length; i++)
                writer.int32(message.appUserStatuses[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewScope
 */
export const AccessReviewScope = new AccessReviewScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewExclusionScope$Type extends MessageType<AccessReviewExclusionScope> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewExclusionScope", [
            { no: 1, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 2, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserStatus", AppUserStatus, "APP_USER_STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewExclusionScope>): AccessReviewExclusionScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserTypes = [];
        message.appUserStatuses = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewExclusionScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewExclusionScope): AccessReviewExclusionScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AppUserType app_user_types */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserTypes.push(reader.int32());
                    else
                        message.appUserTypes.push(reader.int32());
                    break;
                case /* repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserStatuses.push(reader.int32());
                    else
                        message.appUserStatuses.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewExclusionScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AppUserType app_user_types = 1; */
        if (message.appUserTypes.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserTypes.length; i++)
                writer.int32(message.appUserTypes[i]);
            writer.join();
        }
        /* repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2; */
        if (message.appUserStatuses.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserStatuses.length; i++)
                writer.int32(message.appUserStatuses[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewExclusionScope
 */
export const AccessReviewExclusionScope = new AccessReviewExclusionScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncludedUserAttributeValue$Type extends MessageType<IncludedUserAttributeValue> {
    constructor() {
        super("c1.api.accessreview.v1.IncludedUserAttributeValue", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<IncludedUserAttributeValue>): IncludedUserAttributeValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<IncludedUserAttributeValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IncludedUserAttributeValue): IncludedUserAttributeValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IncludedUserAttributeValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.IncludedUserAttributeValue
 */
export const IncludedUserAttributeValue = new IncludedUserAttributeValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncludedUserAttributeValues$Type extends MessageType<IncludedUserAttributeValues> {
    constructor() {
        super("c1.api.accessreview.v1.IncludedUserAttributeValues", [
            { no: 1, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IncludedUserAttributeValue }
        ]);
    }
    create(value?: PartialMessage<IncludedUserAttributeValues>): IncludedUserAttributeValues {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.values = [];
        if (value !== undefined)
            reflectionMergePartial<IncludedUserAttributeValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IncludedUserAttributeValues): IncludedUserAttributeValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.IncludedUserAttributeValue values */ 1:
                    message.values.push(IncludedUserAttributeValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IncludedUserAttributeValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.IncludedUserAttributeValue values = 1; */
        for (let i = 0; i < message.values.length; i++)
            IncludedUserAttributeValue.internalBinaryWrite(message.values[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.IncludedUserAttributeValues
 */
export const IncludedUserAttributeValues = new IncludedUserAttributeValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewInclusionScope$Type extends MessageType<AccessReviewInclusionScope> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewInclusionScope", [
            { no: 1, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 2, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserStatus", AppUserStatus, "APP_USER_STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 3, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.UserStatus", UserStatus], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 4, name: "multi_user_profile_attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => IncludedUserAttributeValues }, options: { "validate.rules": { map: { keys: { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } } } },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "20", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "manager_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "no_account_owners", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewInclusionScope>): AccessReviewInclusionScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserTypes = [];
        message.appUserStatuses = [];
        message.userStatuses = [];
        message.multiUserProfileAttributes = {};
        message.userIds = [];
        message.managerIds = [];
        message.noAccountOwners = false;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewInclusionScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewInclusionScope): AccessReviewInclusionScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AppUserType app_user_types */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserTypes.push(reader.int32());
                    else
                        message.appUserTypes.push(reader.int32());
                    break;
                case /* repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserStatuses.push(reader.int32());
                    else
                        message.appUserStatuses.push(reader.int32());
                    break;
                case /* repeated c1.api.accessreview.v1.UserStatus user_statuses */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userStatuses.push(reader.int32());
                    else
                        message.userStatuses.push(reader.int32());
                    break;
                case /* map<string, c1.api.accessreview.v1.IncludedUserAttributeValues> multi_user_profile_attributes */ 4:
                    this.binaryReadMap4(message.multiUserProfileAttributes, reader, options);
                    break;
                case /* repeated string user_ids */ 5:
                    message.userIds.push(reader.string());
                    break;
                case /* repeated string manager_ids */ 6:
                    message.managerIds.push(reader.string());
                    break;
                case /* bool no_account_owners */ 7:
                    message.noAccountOwners = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap4(map: AccessReviewInclusionScope["multiUserProfileAttributes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AccessReviewInclusionScope["multiUserProfileAttributes"] | undefined, val: AccessReviewInclusionScope["multiUserProfileAttributes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = IncludedUserAttributeValues.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accessreview.v1.AccessReviewInclusionScope.multi_user_profile_attributes");
            }
        }
        map[key ?? ""] = val ?? IncludedUserAttributeValues.create();
    }
    internalBinaryWrite(message: AccessReviewInclusionScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AppUserType app_user_types = 1; */
        if (message.appUserTypes.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserTypes.length; i++)
                writer.int32(message.appUserTypes[i]);
            writer.join();
        }
        /* repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2; */
        if (message.appUserStatuses.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserStatuses.length; i++)
                writer.int32(message.appUserStatuses[i]);
            writer.join();
        }
        /* repeated c1.api.accessreview.v1.UserStatus user_statuses = 3; */
        if (message.userStatuses.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userStatuses.length; i++)
                writer.int32(message.userStatuses[i]);
            writer.join();
        }
        /* map<string, c1.api.accessreview.v1.IncludedUserAttributeValues> multi_user_profile_attributes = 4; */
        for (let k of globalThis.Object.keys(message.multiUserProfileAttributes)) {
            writer.tag(4, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            IncludedUserAttributeValues.internalBinaryWrite(message.multiUserProfileAttributes[k], writer, options);
            writer.join().join();
        }
        /* repeated string user_ids = 5; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.userIds[i]);
        /* repeated string manager_ids = 6; */
        for (let i = 0; i < message.managerIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.managerIds[i]);
        /* bool no_account_owners = 7; */
        if (message.noAccountOwners !== false)
            writer.tag(7, WireType.Varint).bool(message.noAccountOwners);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewInclusionScope
 */
export const AccessReviewInclusionScope = new AccessReviewInclusionScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewExpandMask$Type extends MessageType<AccessReviewExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "created_by_user_id", "policy_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewExpandMask>): AccessReviewExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewExpandMask): AccessReviewExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewExpandMask
 */
export const AccessReviewExpandMask = new AccessReviewExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppEntitlementExpandMask$Type extends MessageType<AccessReviewAppEntitlementExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "policy_id", "app_resource_type_id", "app_resource_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppEntitlementExpandMask>): AccessReviewAppEntitlementExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppEntitlementExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppEntitlementExpandMask): AccessReviewAppEntitlementExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppEntitlementExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask
 */
export const AccessReviewAppEntitlementExpandMask = new AccessReviewAppEntitlementExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateAppEntitlementExpandMask$Type extends MessageType<AccessReviewTemplateAppEntitlementExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "policy_id", "app_resource_type_id", "app_resource_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateAppEntitlementExpandMask>): AccessReviewTemplateAppEntitlementExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateAppEntitlementExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateAppEntitlementExpandMask): AccessReviewTemplateAppEntitlementExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateAppEntitlementExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask
 */
export const AccessReviewTemplateAppEntitlementExpandMask = new AccessReviewTemplateAppEntitlementExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewView$Type extends MessageType<AccessReviewView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewView", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReview },
            { no: 2, name: "created_by_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "object_permissions", kind: "message", T: () => ActorObjectPermissions }
        ]);
    }
    create(value?: PartialMessage<AccessReviewView>): AccessReviewView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.createdByUserPath = "";
        message.policyPath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewView): AccessReviewView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReview access_review */ 1:
                    message.accessReview = AccessReview.internalBinaryRead(reader, reader.uint32(), options, message.accessReview);
                    break;
                case /* string created_by_user_path */ 2:
                    message.createdByUserPath = reader.string();
                    break;
                case /* string policy_path */ 4:
                    message.policyPath = reader.string();
                    break;
                case /* c1.api.iam.v1.ActorObjectPermissions object_permissions */ 5:
                    message.objectPermissions = ActorObjectPermissions.internalBinaryRead(reader, reader.uint32(), options, message.objectPermissions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReview access_review = 1; */
        if (message.accessReview)
            AccessReview.internalBinaryWrite(message.accessReview, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string created_by_user_path = 2; */
        if (message.createdByUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.createdByUserPath);
        /* string policy_path = 4; */
        if (message.policyPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.policyPath);
        /* c1.api.iam.v1.ActorObjectPermissions object_permissions = 5; */
        if (message.objectPermissions)
            ActorObjectPermissions.internalBinaryWrite(message.objectPermissions, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewView
 */
export const AccessReviewView = new AccessReviewView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceListEntitlementsWithMultiAppRequest$Type extends MessageType<AccessReviewServiceListEntitlementsWithMultiAppRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewAppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceListEntitlementsWithMultiAppRequest>): AccessReviewServiceListEntitlementsWithMultiAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceListEntitlementsWithMultiAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceListEntitlementsWithMultiAppRequest): AccessReviewServiceListEntitlementsWithMultiAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AccessReviewAppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceListEntitlementsWithMultiAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.accessreview.v1.AccessReviewAppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessReviewAppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppRequest
 */
export const AccessReviewServiceListEntitlementsWithMultiAppRequest = new AccessReviewServiceListEntitlementsWithMultiAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewAppEntitlementView$Type extends MessageType<AccessReviewAppEntitlementView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewAppEntitlementView", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewAppEntitlementView>): AccessReviewAppEntitlementView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.policyPath = "";
        message.appResourceTypePath = "";
        message.appResourcePath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewAppEntitlementView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewAppEntitlementView): AccessReviewAppEntitlementView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlement app_entitlement */ 1:
                    message.appEntitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlement);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string policy_path */ 3:
                    message.policyPath = reader.string();
                    break;
                case /* string app_resource_type_path */ 4:
                    message.appResourceTypePath = reader.string();
                    break;
                case /* string app_resource_path */ 5:
                    message.appResourcePath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewAppEntitlementView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlement app_entitlement = 1; */
        if (message.appEntitlement)
            AppEntitlement.internalBinaryWrite(message.appEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string policy_path = 3; */
        if (message.policyPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.policyPath);
        /* string app_resource_type_path = 4; */
        if (message.appResourceTypePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appResourceTypePath);
        /* string app_resource_path = 5; */
        if (message.appResourcePath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appResourcePath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewAppEntitlementView
 */
export const AccessReviewAppEntitlementView = new AccessReviewAppEntitlementView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceListEntitlementsWithMultiAppResponse$Type extends MessageType<AccessReviewServiceListEntitlementsWithMultiAppResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewAppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceListEntitlementsWithMultiAppResponse>): AccessReviewServiceListEntitlementsWithMultiAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceListEntitlementsWithMultiAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceListEntitlementsWithMultiAppResponse): AccessReviewServiceListEntitlementsWithMultiAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView list */ 1:
                    message.list.push(AccessReviewAppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceListEntitlementsWithMultiAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewAppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewAppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceListEntitlementsWithMultiAppResponse
 */
export const AccessReviewServiceListEntitlementsWithMultiAppResponse = new AccessReviewServiceListEntitlementsWithMultiAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceGetResponse$Type extends MessageType<AccessReviewServiceGetResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceGetResponse", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceGetResponse>): AccessReviewServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceGetResponse): AccessReviewServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewView access_review */ 1:
                    message.accessReview = AccessReviewView.internalBinaryRead(reader, reader.uint32(), options, message.accessReview);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewView access_review = 1; */
        if (message.accessReview)
            AccessReviewView.internalBinaryWrite(message.accessReview, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceGetResponse
 */
export const AccessReviewServiceGetResponse = new AccessReviewServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceCreateResponse$Type extends MessageType<AccessReviewServiceCreateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceCreateResponse", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceCreateResponse>): AccessReviewServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceCreateResponse): AccessReviewServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewView access_review */ 1:
                    message.accessReview = AccessReviewView.internalBinaryRead(reader, reader.uint32(), options, message.accessReview);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewView access_review = 1; */
        if (message.accessReview)
            AccessReviewView.internalBinaryWrite(message.accessReview, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceCreateResponse
 */
export const AccessReviewServiceCreateResponse = new AccessReviewServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceUpdateResponse$Type extends MessageType<AccessReviewServiceUpdateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceUpdateResponse", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceUpdateResponse>): AccessReviewServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceUpdateResponse): AccessReviewServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewView access_review */ 1:
                    message.accessReview = AccessReviewView.internalBinaryRead(reader, reader.uint32(), options, message.accessReview);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewView access_review = 1; */
        if (message.accessReview)
            AccessReviewView.internalBinaryWrite(message.accessReview, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceUpdateResponse
 */
export const AccessReviewServiceUpdateResponse = new AccessReviewServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessReviewSelectionRequest$Type extends MessageType<GetAccessReviewSelectionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetAccessReviewSelectionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "selection_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAccessReviewSelectionRequest>): GetAccessReviewSelectionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.selectionId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccessReviewSelectionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccessReviewSelectionRequest): GetAccessReviewSelectionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string selection_id */ 2:
                    message.selectionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccessReviewSelectionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string selection_id = 2; */
        if (message.selectionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.selectionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetAccessReviewSelectionRequest
 */
export const GetAccessReviewSelectionRequest = new GetAccessReviewSelectionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionExpandMask$Type extends MessageType<AccessReviewSelectionExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_user_id", "user_id", "entitlement_ids", "certify_task_id", "app_id", "policy_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelectionExpandMask>): AccessReviewSelectionExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionExpandMask): AccessReviewSelectionExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionExpandMask
 */
export const AccessReviewSelectionExpandMask = new AccessReviewSelectionExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlement$Type extends MessageType<AccessReviewEntitlement> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlement", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlement>): AccessReviewEntitlement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.accessReviewId = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.policyId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlement): AccessReviewEntitlement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string access_review_id */ 2:
                    message.accessReviewId = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 4:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string policy_id */ 5:
                    message.policyId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 8:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string access_review_id = 2; */
        if (message.accessReviewId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewId);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 4; */
        if (message.appEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string policy_id = 5; */
        if (message.policyId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.policyId);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 8; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlement
 */
export const AccessReviewEntitlement = new AccessReviewEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementView$Type extends MessageType<AccessReviewEntitlementView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementView", [
            { no: 1, name: "access_review_entitlement", kind: "message", T: () => AccessReviewEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementView>): AccessReviewEntitlementView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.entitlementPath = "";
        message.policyPath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementView): AccessReviewEntitlementView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewEntitlement access_review_entitlement */ 1:
                    message.accessReviewEntitlement = AccessReviewEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewEntitlement);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string entitlement_path */ 3:
                    message.entitlementPath = reader.string();
                    break;
                case /* string policy_path */ 4:
                    message.policyPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewEntitlement access_review_entitlement = 1; */
        if (message.accessReviewEntitlement)
            AccessReviewEntitlement.internalBinaryWrite(message.accessReviewEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string entitlement_path = 3; */
        if (message.entitlementPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementPath);
        /* string policy_path = 4; */
        if (message.policyPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.policyPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementView
 */
export const AccessReviewEntitlementView = new AccessReviewEntitlementView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionRef$Type extends MessageType<AccessReviewSelectionRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelectionRef>): AccessReviewSelectionRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionRef): AccessReviewSelectionRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionRef
 */
export const AccessReviewSelectionRef = new AccessReviewSelectionRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceRef$Type extends MessageType<AccessReviewConnectorSourceRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceRef", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceRef>): AccessReviewConnectorSourceRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.connectorId = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceRef): AccessReviewConnectorSourceRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceRef
 */
export const AccessReviewConnectorSourceRef = new AccessReviewConnectorSourceRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelection$Type extends MessageType<AccessReviewSelection> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelection", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "entitlement_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "revoke_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "state", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewSelectionState", AccessReviewSelectionState, "ACCESS_REVIEW_SELECTION_STATE_"] },
            { no: 10, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelection>): AccessReviewSelection {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.accessReviewId = "";
        message.appUserId = "";
        message.userId = "";
        message.appId = "";
        message.entitlementIds = [];
        message.certifyTaskId = "";
        message.revokeTaskId = "";
        message.state = 0;
        message.policyId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelection>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelection): AccessReviewSelection {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string access_review_id */ 2:
                    message.accessReviewId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                case /* string app_id */ 5:
                    message.appId = reader.string();
                    break;
                case /* repeated string entitlement_ids */ 6:
                    message.entitlementIds.push(reader.string());
                    break;
                case /* string certify_task_id */ 7:
                    message.certifyTaskId = reader.string();
                    break;
                case /* string revoke_task_id */ 8:
                    message.revokeTaskId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewSelectionState state */ 9:
                    message.state = reader.int32();
                    break;
                case /* string policy_id */ 10:
                    message.policyId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 11:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 12:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 13:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelection, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string access_review_id = 2; */
        if (message.accessReviewId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        /* string app_id = 5; */
        if (message.appId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appId);
        /* repeated string entitlement_ids = 6; */
        for (let i = 0; i < message.entitlementIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.entitlementIds[i]);
        /* string certify_task_id = 7; */
        if (message.certifyTaskId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.certifyTaskId);
        /* string revoke_task_id = 8; */
        if (message.revokeTaskId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.revokeTaskId);
        /* c1.api.accessreview.v1.AccessReviewSelectionState state = 9; */
        if (message.state !== 0)
            writer.tag(9, WireType.Varint).int32(message.state);
        /* string policy_id = 10; */
        if (message.policyId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.policyId);
        /* google.protobuf.Timestamp created_at = 11; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 12; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 13; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelection
 */
export const AccessReviewSelection = new AccessReviewSelection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSelectionView$Type extends MessageType<AccessReviewSelectionView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSelectionView", [
            { no: 1, name: "access_review_selection", kind: "message", T: () => AccessReviewSelection },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "entitlements_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "cert_task_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSelectionView>): AccessReviewSelectionView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserPath = "";
        message.userPath = "";
        message.entitlementsPath = "";
        message.certTaskPath = "";
        message.appPath = "";
        message.policyPath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSelectionView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSelectionView): AccessReviewSelectionView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewSelection access_review_selection */ 1:
                    message.accessReviewSelection = AccessReviewSelection.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewSelection);
                    break;
                case /* string app_user_path */ 2:
                    message.appUserPath = reader.string();
                    break;
                case /* string user_path */ 3:
                    message.userPath = reader.string();
                    break;
                case /* string entitlements_path */ 4:
                    message.entitlementsPath = reader.string();
                    break;
                case /* string cert_task_path */ 5:
                    message.certTaskPath = reader.string();
                    break;
                case /* string app_path */ 6:
                    message.appPath = reader.string();
                    break;
                case /* string policy_path */ 7:
                    message.policyPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSelectionView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewSelection access_review_selection = 1; */
        if (message.accessReviewSelection)
            AccessReviewSelection.internalBinaryWrite(message.accessReviewSelection, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_path = 2; */
        if (message.appUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserPath);
        /* string user_path = 3; */
        if (message.userPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userPath);
        /* string entitlements_path = 4; */
        if (message.entitlementsPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.entitlementsPath);
        /* string cert_task_path = 5; */
        if (message.certTaskPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.certTaskPath);
        /* string app_path = 6; */
        if (message.appPath !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appPath);
        /* string policy_path = 7; */
        if (message.policyPath !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.policyPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSelectionView
 */
export const AccessReviewSelectionView = new AccessReviewSelectionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceGetRequest$Type extends MessageType<AccessReviewServiceGetRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceGetRequest>): AccessReviewServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceGetRequest): AccessReviewServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask */ 2:
                    message.expandMask = AccessReviewExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 2; */
        if (message.expandMask)
            AccessReviewExpandMask.internalBinaryWrite(message.expandMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceGetRequest
 */
export const AccessReviewServiceGetRequest = new AccessReviewServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceUpdateRequest$Type extends MessageType<AccessReviewServiceUpdateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceUpdateRequest", [
            { no: 1, name: "access_review", kind: "message", T: () => AccessReview, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceUpdateRequest>): AccessReviewServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceUpdateRequest): AccessReviewServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReview access_review */ 1:
                    message.accessReview = AccessReview.internalBinaryRead(reader, reader.uint32(), options, message.accessReview);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask */ 3:
                    message.expandMask = AccessReviewExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReview access_review = 1; */
        if (message.accessReview)
            AccessReview.internalBinaryWrite(message.accessReview, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 3; */
        if (message.expandMask)
            AccessReviewExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceUpdateRequest
 */
export const AccessReviewServiceUpdateRequest = new AccessReviewServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceCreateRequest$Type extends MessageType<AccessReviewServiceCreateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 3, name: "completion_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask },
            { no: 7, name: "notification_config", kind: "message", T: () => NotificationConfig },
            { no: 8, name: "duplicate_from", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 9, name: "scope_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewScopeType", AccessReviewScopeType, "ACCESS_REVIEW_SCOPE_TYPE_"] },
            { no: 10, name: "scope_v2", kind: "message", T: () => AccessReviewScopeV2 }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceCreateRequest>): AccessReviewServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.policyId = "";
        message.ownerIds = [];
        message.duplicateFrom = "";
        message.scopeType = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceCreateRequest): AccessReviewServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp completion_date */ 3:
                    message.completionDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completionDate);
                    break;
                case /* string policy_id */ 4:
                    message.policyId = reader.string();
                    break;
                case /* repeated string owner_ids */ 5:
                    message.ownerIds.push(reader.string());
                    break;
                case /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask */ 6:
                    message.expandMask = AccessReviewExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* c1.api.accessreview.v1.NotificationConfig notification_config */ 7:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                case /* string duplicate_from */ 8:
                    message.duplicateFrom = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeType scope_type */ 9:
                    message.scopeType = reader.int32();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 */ 10:
                    message.scopeV2 = AccessReviewScopeV2.internalBinaryRead(reader, reader.uint32(), options, message.scopeV2);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp completion_date = 3; */
        if (message.completionDate)
            Timestamp.internalBinaryWrite(message.completionDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string policy_id = 4; */
        if (message.policyId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.policyId);
        /* repeated string owner_ids = 5; */
        for (let i = 0; i < message.ownerIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.ownerIds[i]);
        /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 6; */
        if (message.expandMask)
            AccessReviewExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.NotificationConfig notification_config = 7; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string duplicate_from = 8; */
        if (message.duplicateFrom !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.duplicateFrom);
        /* c1.api.accessreview.v1.AccessReviewScopeType scope_type = 9; */
        if (message.scopeType !== 0)
            writer.tag(9, WireType.Varint).int32(message.scopeType);
        /* c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 10; */
        if (message.scopeV2)
            AccessReviewScopeV2.internalBinaryWrite(message.scopeV2, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceCreateRequest
 */
export const AccessReviewServiceCreateRequest = new AccessReviewServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceDeleteRequest$Type extends MessageType<AccessReviewServiceDeleteRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceDeleteRequest>): AccessReviewServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceDeleteRequest): AccessReviewServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceDeleteRequest
 */
export const AccessReviewServiceDeleteRequest = new AccessReviewServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceDeleteResponse$Type extends MessageType<AccessReviewServiceDeleteResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<AccessReviewServiceDeleteResponse>): AccessReviewServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceDeleteResponse): AccessReviewServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceDeleteResponse
 */
export const AccessReviewServiceDeleteResponse = new AccessReviewServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceListRequest$Type extends MessageType<AccessReviewServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AccessReviewExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceListRequest>): AccessReviewServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceListRequest): AccessReviewServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask */ 3:
                    message.expandMask = AccessReviewExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewExpandMask expand_mask = 3; */
        if (message.expandMask)
            AccessReviewExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceListRequest
 */
export const AccessReviewServiceListRequest = new AccessReviewServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewServiceListResponse$Type extends MessageType<AccessReviewServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewServiceListResponse>): AccessReviewServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewServiceListResponse): AccessReviewServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewView list */ 1:
                    message.list.push(AccessReviewView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewServiceListResponse
 */
export const AccessReviewServiceListResponse = new AccessReviewServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewReportRef$Type extends MessageType<AccessReviewReportRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewReportRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewReportRef>): AccessReviewReportRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewReportRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewReportRef): AccessReviewReportRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewReportRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewReportRef
 */
export const AccessReviewReportRef = new AccessReviewReportRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewReport$Type extends MessageType<AccessReviewReport> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewReport", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.accessreview.v1.ReportState", ReportState, "REPORT_STATE_"] },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "hashes", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewReport>): AccessReviewReport {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.accessReviewId = "";
        message.downloadUrl = "";
        message.state = 0;
        message.hashes = {};
        if (value !== undefined)
            reflectionMergePartial<AccessReviewReport>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewReport): AccessReviewReport {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string access_review_id */ 2:
                    message.accessReviewId = reader.string();
                    break;
                case /* string download_url */ 3:
                    message.downloadUrl = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ReportState state */ 4:
                    message.state = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* map<int32, string> hashes */ 6:
                    this.binaryReadMap6(message.hashes, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: AccessReviewReport["hashes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AccessReviewReport["hashes"] | undefined, val: AccessReviewReport["hashes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accessreview.v1.AccessReviewReport.hashes");
            }
        }
        map[key ?? 0] = val ?? "";
    }
    internalBinaryWrite(message: AccessReviewReport, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string access_review_id = 2; */
        if (message.accessReviewId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewId);
        /* string download_url = 3; */
        if (message.downloadUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.downloadUrl);
        /* c1.api.accessreview.v1.ReportState state = 4; */
        if (message.state !== 0)
            writer.tag(4, WireType.Varint).int32(message.state);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<int32, string> hashes = 6; */
        for (let k of globalThis.Object.keys(message.hashes))
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k)).tag(2, WireType.LengthDelimited).string(message.hashes[k as any]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewReport
 */
export const AccessReviewReport = new AccessReviewReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewReportServiceListRequest$Type extends MessageType<AccessReviewReportServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewReportServiceListRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewReportRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewReportServiceListRequest>): AccessReviewReportServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewReportServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewReportServiceListRequest): AccessReviewReportServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewReportRef refs */ 6:
                    message.refs.push(AccessReviewReportRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewReportServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.accessreview.v1.AccessReviewReportRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewReportRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewReportServiceListRequest
 */
export const AccessReviewReportServiceListRequest = new AccessReviewReportServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewReportServiceListResponse$Type extends MessageType<AccessReviewReportServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewReportServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewReport },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewReportServiceListResponse>): AccessReviewReportServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewReportServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewReportServiceListResponse): AccessReviewReportServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewReport list */ 1:
                    message.list.push(AccessReviewReport.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewReportServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewReport list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewReport.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewReportServiceListResponse
 */
export const AccessReviewReportServiceListResponse = new AccessReviewReportServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceServiceListOutdatedRequest$Type extends MessageType<AccessReviewConnectorSourceServiceListOutdatedRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewConnectorSourceExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceServiceListOutdatedRequest>): AccessReviewConnectorSourceServiceListOutdatedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceServiceListOutdatedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceServiceListOutdatedRequest): AccessReviewConnectorSourceServiceListOutdatedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask */ 4:
                    message.expandMask = AccessReviewConnectorSourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceServiceListOutdatedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessReviewConnectorSourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedRequest
 */
export const AccessReviewConnectorSourceServiceListOutdatedRequest = new AccessReviewConnectorSourceServiceListOutdatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceServiceListOutdatedResponse$Type extends MessageType<AccessReviewConnectorSourceServiceListOutdatedResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceServiceListOutdatedResponse>): AccessReviewConnectorSourceServiceListOutdatedResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceServiceListOutdatedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceServiceListOutdatedResponse): AccessReviewConnectorSourceServiceListOutdatedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list */ 1:
                    message.list.push(AccessReviewConnectorSourceView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceServiceListOutdatedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewConnectorSourceView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceServiceListOutdatedResponse
 */
export const AccessReviewConnectorSourceServiceListOutdatedResponse = new AccessReviewConnectorSourceServiceListOutdatedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementRollupByApp$Type extends MessageType<AccessReviewEntitlementRollupByApp> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementRollup }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementRollupByApp>): AccessReviewEntitlementRollupByApp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementRollupByApp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementRollupByApp): AccessReviewEntitlementRollupByApp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list */ 2:
                    message.list.push(AccessReviewEntitlementRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementRollupByApp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 2; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewEntitlementRollup.internalBinaryWrite(message.list[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupByApp
 */
export const AccessReviewEntitlementRollupByApp = new AccessReviewEntitlementRollupByApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementRollupByAppUser$Type extends MessageType<AccessReviewEntitlementRollupByAppUser> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementRollupByAppUser", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementRollup }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementRollupByAppUser>): AccessReviewEntitlementRollupByAppUser {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementRollupByAppUser>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementRollupByAppUser): AccessReviewEntitlementRollupByAppUser {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUser app_user */ 1:
                    message.appUser = AppUser.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list */ 2:
                    message.list.push(AccessReviewEntitlementRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementRollupByAppUser, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUser app_user = 1; */
        if (message.appUser)
            AppUser.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewEntitlementRollup list = 2; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewEntitlementRollup.internalBinaryWrite(message.list[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupByAppUser
 */
export const AccessReviewEntitlementRollupByAppUser = new AccessReviewEntitlementRollupByAppUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementRollup$Type extends MessageType<AccessReviewEntitlementRollup> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementRollup", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "assigned_tasks", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "completed_tasks_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "pending_submission_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementRollup>): AccessReviewEntitlementRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assignedTasks = 0;
        message.completedTasksCount = 0;
        message.appResourceTypePath = "";
        message.appResourcePath = "";
        message.appPath = "";
        message.pendingSubmissionCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementRollup): AccessReviewEntitlementRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlement app_entitlement */ 1:
                    message.appEntitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlement);
                    break;
                case /* int32 assigned_tasks */ 2:
                    message.assignedTasks = reader.int32();
                    break;
                case /* int64 completed_tasks_count */ 3:
                    message.completedTasksCount = reader.int64().toNumber();
                    break;
                case /* string app_resource_type_path */ 4:
                    message.appResourceTypePath = reader.string();
                    break;
                case /* string app_resource_path */ 5:
                    message.appResourcePath = reader.string();
                    break;
                case /* string app_path */ 6:
                    message.appPath = reader.string();
                    break;
                case /* int64 pending_submission_count */ 7:
                    message.pendingSubmissionCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlement app_entitlement = 1; */
        if (message.appEntitlement)
            AppEntitlement.internalBinaryWrite(message.appEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 assigned_tasks = 2; */
        if (message.assignedTasks !== 0)
            writer.tag(2, WireType.Varint).int32(message.assignedTasks);
        /* int64 completed_tasks_count = 3; */
        if (message.completedTasksCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.completedTasksCount);
        /* string app_resource_type_path = 4; */
        if (message.appResourceTypePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appResourceTypePath);
        /* string app_resource_path = 5; */
        if (message.appResourcePath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appResourcePath);
        /* string app_path = 6; */
        if (message.appPath !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appPath);
        /* int64 pending_submission_count = 7; */
        if (message.pendingSubmissionCount !== 0)
            writer.tag(7, WireType.Varint).int64(message.pendingSubmissionCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollup
 */
export const AccessReviewEntitlementRollup = new AccessReviewEntitlementRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementRollupExpandMask$Type extends MessageType<AccessReviewEntitlementRollupExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_resource_type_id", "app_resource_id", "app_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementRollupExpandMask>): AccessReviewEntitlementRollupExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementRollupExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementRollupExpandMask): AccessReviewEntitlementRollupExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementRollupExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementRollupExpandMask
 */
export const AccessReviewEntitlementRollupExpandMask = new AccessReviewEntitlementRollupExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreviewExpandMask$Type extends MessageType<AccessReviewEntitlementPreviewExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_user_id", "app_id", "app_entitlement_id", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementPreviewExpandMask>): AccessReviewEntitlementPreviewExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementPreviewExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementPreviewExpandMask): AccessReviewEntitlementPreviewExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementPreviewExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask
 */
export const AccessReviewEntitlementPreviewExpandMask = new AccessReviewEntitlementPreviewExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreviewServiceSearchRequest$Type extends MessageType<AccessReviewEntitlementPreviewServiceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => AccessReviewEntitlementPreviewExpandMask },
            { no: 8, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementPreviewServiceSearchRequest>): AccessReviewEntitlementPreviewServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementPreviewServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementPreviewServiceSearchRequest): AccessReviewEntitlementPreviewServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask expand_mask */ 7:
                    message.expandMask = AccessReviewEntitlementPreviewExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string access_review_id */ 8:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementPreviewServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* c1.api.accessreview.v1.AccessReviewEntitlementPreviewExpandMask expand_mask = 7; */
        if (message.expandMask)
            AccessReviewEntitlementPreviewExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string access_review_id = 8; */
        if (message.accessReviewId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchRequest
 */
export const AccessReviewEntitlementPreviewServiceSearchRequest = new AccessReviewEntitlementPreviewServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreview$Type extends MessageType<AccessReviewEntitlementPreview> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreview", [
            { no: 1, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "entitlement_expiration_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "entitlement_discovered_time", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementPreview>): AccessReviewEntitlementPreview {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserId = "";
        message.entitlementId = "";
        message.appId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementPreview>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementPreview): AccessReviewEntitlementPreview {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_user_id */ 1:
                    message.appUserId = reader.string();
                    break;
                case /* string entitlement_id */ 2:
                    message.entitlementId = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                case /* google.protobuf.Timestamp entitlement_expiration_time */ 5:
                    message.entitlementExpirationTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.entitlementExpirationTime);
                    break;
                case /* google.protobuf.Timestamp entitlement_discovered_time */ 6:
                    message.entitlementDiscoveredTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.entitlementDiscoveredTime);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementPreview, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_user_id = 1; */
        if (message.appUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appUserId);
        /* string entitlement_id = 2; */
        if (message.entitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementId);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        /* google.protobuf.Timestamp entitlement_expiration_time = 5; */
        if (message.entitlementExpirationTime)
            Timestamp.internalBinaryWrite(message.entitlementExpirationTime, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp entitlement_discovered_time = 6; */
        if (message.entitlementDiscoveredTime)
            Timestamp.internalBinaryWrite(message.entitlementDiscoveredTime, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreview
 */
export const AccessReviewEntitlementPreview = new AccessReviewEntitlementPreview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreviewView$Type extends MessageType<AccessReviewEntitlementPreviewView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreviewView", [
            { no: 1, name: "scope", kind: "message", T: () => AccessReviewEntitlementPreview },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_entitlement_user_binding", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementPreviewView>): AccessReviewEntitlementPreviewView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserPath = "";
        message.entitlementPath = "";
        message.appPath = "";
        message.appEntitlementUserBinding = "";
        message.userPath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementPreviewView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementPreviewView): AccessReviewEntitlementPreviewView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewEntitlementPreview scope */ 1:
                    message.scope = AccessReviewEntitlementPreview.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* string app_user_path */ 2:
                    message.appUserPath = reader.string();
                    break;
                case /* string entitlement_path */ 3:
                    message.entitlementPath = reader.string();
                    break;
                case /* string app_path */ 4:
                    message.appPath = reader.string();
                    break;
                case /* string app_entitlement_user_binding */ 5:
                    message.appEntitlementUserBinding = reader.string();
                    break;
                case /* string user_path */ 6:
                    message.userPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementPreviewView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewEntitlementPreview scope = 1; */
        if (message.scope)
            AccessReviewEntitlementPreview.internalBinaryWrite(message.scope, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_path = 2; */
        if (message.appUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserPath);
        /* string entitlement_path = 3; */
        if (message.entitlementPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementPath);
        /* string app_path = 4; */
        if (message.appPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appPath);
        /* string app_entitlement_user_binding = 5; */
        if (message.appEntitlementUserBinding !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appEntitlementUserBinding);
        /* string user_path = 6; */
        if (message.userPath !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewView
 */
export const AccessReviewEntitlementPreviewView = new AccessReviewEntitlementPreviewView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewEntitlementPreviewServiceSearchResponse$Type extends MessageType<AccessReviewEntitlementPreviewServiceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewEntitlementPreviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewEntitlementPreviewServiceSearchResponse>): AccessReviewEntitlementPreviewServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewEntitlementPreviewServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewEntitlementPreviewServiceSearchResponse): AccessReviewEntitlementPreviewServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewEntitlementPreviewView list */ 1:
                    message.list.push(AccessReviewEntitlementPreviewView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewEntitlementPreviewServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewEntitlementPreviewView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewEntitlementPreviewView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewEntitlementPreviewServiceSearchResponse
 */
export const AccessReviewEntitlementPreviewServiceSearchResponse = new AccessReviewEntitlementPreviewServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewRef$Type extends MessageType<AccessReviewRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewRef>): AccessReviewRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewRef): AccessReviewRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewRef
 */
export const AccessReviewRef = new AccessReviewRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplate$Type extends MessageType<AccessReviewTemplate> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplate", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "access_review_duration", kind: "message", T: () => Duration },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 8, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 9, name: "inclusion_scope", kind: "message", T: () => AccessReviewInclusionScope },
            { no: 10, name: "recurrence_rule", kind: "message", T: () => RecurrenceRule },
            { no: 11, name: "next_scheduled_campaign_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{}] } } },
            { no: 12, name: "notification_config", kind: "message", T: () => NotificationConfig },
            { no: 13, name: "is_campaign_schedule_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "slack_channel", kind: "message", oneof: "slackChannelDetails", T: () => SlackChannel },
            { no: 14, name: "occurrences", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "scope", kind: "message", T: () => AccessReviewScopeV2 },
            { no: 16, name: "review_instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 17, name: "use_policy_override", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "default_view", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewViewType", AccessReviewViewType, "ACCESS_REVIEW_VIEW_TYPE_"] },
            { no: 19, name: "auto_generate_report", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "scope_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewScopeType", AccessReviewScopeType, "ACCESS_REVIEW_SCOPE_TYPE_"] },
            { no: 21, name: "exempt_certified_access_conflicts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "signature_config", kind: "message", T: () => ReviewSignatureConfig },
            { no: 23, name: "auto_start_campaign", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "accuracy_issue_action", kind: "enum", T: () => ["c1.api.accessreview.v1.AccuracyIssueAction", AccuracyIssueAction, "ACCURACY_ISSUE_ACTION_"] },
            { no: 25, name: "auto_close_campaign", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "auto_close_decision", kind: "enum", T: () => ["c1.api.accessreview.v1.CloseDecision", CloseDecision, "CLOSE_DECISION_"] }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access Review Template" } }] } });
    }
    create(value?: PartialMessage<AccessReviewTemplate>): AccessReviewTemplate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.policyId = "";
        message.description = "";
        message.displayName = "";
        message.isCampaignScheduleEnabled = false;
        message.slackChannelDetails = { oneofKind: undefined };
        message.occurrences = 0;
        message.reviewInstructions = "";
        message.usePolicyOverride = false;
        message.defaultView = 0;
        message.autoGenerateReport = false;
        message.scopeType = 0;
        message.exemptCertifiedAccessConflicts = false;
        message.autoStartCampaign = false;
        message.accuracyIssueAction = 0;
        message.autoCloseCampaign = false;
        message.autoCloseDecision = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplate): AccessReviewTemplate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string policy_id */ 2:
                    message.policyId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Duration access_review_duration */ 6:
                    message.accessReviewDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewDuration);
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* string display_name */ 8:
                    message.displayName = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewInclusionScope inclusion_scope */ 9:
                    message.inclusionScope = AccessReviewInclusionScope.internalBinaryRead(reader, reader.uint32(), options, message.inclusionScope);
                    break;
                case /* c1.api.accessreview.v1.RecurrenceRule recurrence_rule */ 10:
                    message.recurrenceRule = RecurrenceRule.internalBinaryRead(reader, reader.uint32(), options, message.recurrenceRule);
                    break;
                case /* google.protobuf.Timestamp next_scheduled_campaign_at */ 11:
                    message.nextScheduledCampaignAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.nextScheduledCampaignAt);
                    break;
                case /* c1.api.accessreview.v1.NotificationConfig notification_config */ 12:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                case /* bool is_campaign_schedule_enabled */ 13:
                    message.isCampaignScheduleEnabled = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.SlackChannel slack_channel */ 100:
                    message.slackChannelDetails = {
                        oneofKind: "slackChannel",
                        slackChannel: SlackChannel.internalBinaryRead(reader, reader.uint32(), options, (message.slackChannelDetails as any).slackChannel)
                    };
                    break;
                case /* int32 occurrences */ 14:
                    message.occurrences = reader.int32();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeV2 scope */ 15:
                    message.scope = AccessReviewScopeV2.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* string review_instructions */ 16:
                    message.reviewInstructions = reader.string();
                    break;
                case /* bool use_policy_override */ 17:
                    message.usePolicyOverride = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewViewType default_view */ 18:
                    message.defaultView = reader.int32();
                    break;
                case /* bool auto_generate_report */ 19:
                    message.autoGenerateReport = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeType scope_type */ 20:
                    message.scopeType = reader.int32();
                    break;
                case /* bool exempt_certified_access_conflicts */ 21:
                    message.exemptCertifiedAccessConflicts = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.ReviewSignatureConfig signature_config */ 22:
                    message.signatureConfig = ReviewSignatureConfig.internalBinaryRead(reader, reader.uint32(), options, message.signatureConfig);
                    break;
                case /* bool auto_start_campaign */ 23:
                    message.autoStartCampaign = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.AccuracyIssueAction accuracy_issue_action */ 24:
                    message.accuracyIssueAction = reader.int32();
                    break;
                case /* bool auto_close_campaign */ 25:
                    message.autoCloseCampaign = reader.bool();
                    break;
                case /* c1.api.accessreview.v1.CloseDecision auto_close_decision */ 26:
                    message.autoCloseDecision = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string policy_id = 2; */
        if (message.policyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.policyId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration access_review_duration = 6; */
        if (message.accessReviewDuration)
            Duration.internalBinaryWrite(message.accessReviewDuration, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* string display_name = 8; */
        if (message.displayName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.displayName);
        /* c1.api.accessreview.v1.AccessReviewInclusionScope inclusion_scope = 9; */
        if (message.inclusionScope)
            AccessReviewInclusionScope.internalBinaryWrite(message.inclusionScope, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.RecurrenceRule recurrence_rule = 10; */
        if (message.recurrenceRule)
            RecurrenceRule.internalBinaryWrite(message.recurrenceRule, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp next_scheduled_campaign_at = 11; */
        if (message.nextScheduledCampaignAt)
            Timestamp.internalBinaryWrite(message.nextScheduledCampaignAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.NotificationConfig notification_config = 12; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* bool is_campaign_schedule_enabled = 13; */
        if (message.isCampaignScheduleEnabled !== false)
            writer.tag(13, WireType.Varint).bool(message.isCampaignScheduleEnabled);
        /* int32 occurrences = 14; */
        if (message.occurrences !== 0)
            writer.tag(14, WireType.Varint).int32(message.occurrences);
        /* c1.api.accessreview.v1.AccessReviewScopeV2 scope = 15; */
        if (message.scope)
            AccessReviewScopeV2.internalBinaryWrite(message.scope, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string review_instructions = 16; */
        if (message.reviewInstructions !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.reviewInstructions);
        /* bool use_policy_override = 17; */
        if (message.usePolicyOverride !== false)
            writer.tag(17, WireType.Varint).bool(message.usePolicyOverride);
        /* c1.api.accessreview.v1.AccessReviewViewType default_view = 18; */
        if (message.defaultView !== 0)
            writer.tag(18, WireType.Varint).int32(message.defaultView);
        /* bool auto_generate_report = 19; */
        if (message.autoGenerateReport !== false)
            writer.tag(19, WireType.Varint).bool(message.autoGenerateReport);
        /* c1.api.accessreview.v1.AccessReviewScopeType scope_type = 20; */
        if (message.scopeType !== 0)
            writer.tag(20, WireType.Varint).int32(message.scopeType);
        /* bool exempt_certified_access_conflicts = 21; */
        if (message.exemptCertifiedAccessConflicts !== false)
            writer.tag(21, WireType.Varint).bool(message.exemptCertifiedAccessConflicts);
        /* c1.api.accessreview.v1.ReviewSignatureConfig signature_config = 22; */
        if (message.signatureConfig)
            ReviewSignatureConfig.internalBinaryWrite(message.signatureConfig, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* bool auto_start_campaign = 23; */
        if (message.autoStartCampaign !== false)
            writer.tag(23, WireType.Varint).bool(message.autoStartCampaign);
        /* c1.api.accessreview.v1.AccuracyIssueAction accuracy_issue_action = 24; */
        if (message.accuracyIssueAction !== 0)
            writer.tag(24, WireType.Varint).int32(message.accuracyIssueAction);
        /* bool auto_close_campaign = 25; */
        if (message.autoCloseCampaign !== false)
            writer.tag(25, WireType.Varint).bool(message.autoCloseCampaign);
        /* c1.api.accessreview.v1.CloseDecision auto_close_decision = 26; */
        if (message.autoCloseDecision !== 0)
            writer.tag(26, WireType.Varint).int32(message.autoCloseDecision);
        /* c1.api.accessreview.v1.SlackChannel slack_channel = 100; */
        if (message.slackChannelDetails.oneofKind === "slackChannel")
            SlackChannel.internalBinaryWrite(message.slackChannelDetails.slackChannel, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplate
 */
export const AccessReviewTemplate = new AccessReviewTemplate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecurrenceRule$Type extends MessageType<RecurrenceRule> {
    constructor() {
        super("c1.api.accessreview.v1.RecurrenceRule", [
            { no: 1, name: "frequency", kind: "enum", T: () => ["c1.api.accessreview.v1.RecurrenceRule.Frequency", RecurrenceRule_Frequency, "FREQUENCY_"] },
            { no: 2, name: "interval", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "end_date", kind: "message", oneof: "endCondition", T: () => Timestamp },
            { no: 5, name: "occurrences", kind: "scalar", oneof: "endCondition", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<RecurrenceRule>): RecurrenceRule {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.frequency = 0;
        message.interval = 0;
        message.endCondition = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<RecurrenceRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RecurrenceRule): RecurrenceRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.RecurrenceRule.Frequency frequency */ 1:
                    message.frequency = reader.int32();
                    break;
                case /* int32 interval */ 2:
                    message.interval = reader.int32();
                    break;
                case /* google.protobuf.Timestamp start_date */ 3:
                    message.startDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startDate);
                    break;
                case /* google.protobuf.Timestamp end_date */ 4:
                    message.endCondition = {
                        oneofKind: "endDate",
                        endDate: Timestamp.internalBinaryRead(reader, reader.uint32(), options, (message.endCondition as any).endDate)
                    };
                    break;
                case /* int32 occurrences */ 5:
                    message.endCondition = {
                        oneofKind: "occurrences",
                        occurrences: reader.int32()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RecurrenceRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.RecurrenceRule.Frequency frequency = 1; */
        if (message.frequency !== 0)
            writer.tag(1, WireType.Varint).int32(message.frequency);
        /* int32 interval = 2; */
        if (message.interval !== 0)
            writer.tag(2, WireType.Varint).int32(message.interval);
        /* google.protobuf.Timestamp start_date = 3; */
        if (message.startDate)
            Timestamp.internalBinaryWrite(message.startDate, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_date = 4; */
        if (message.endCondition.oneofKind === "endDate")
            Timestamp.internalBinaryWrite(message.endCondition.endDate, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 occurrences = 5; */
        if (message.endCondition.oneofKind === "occurrences")
            writer.tag(5, WireType.Varint).int32(message.endCondition.occurrences);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.RecurrenceRule
 */
export const RecurrenceRule = new RecurrenceRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceCreateRequest$Type extends MessageType<AccessReviewTemplateServiceCreateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 3, name: "access_review_duration", kind: "message", T: () => Duration },
            { no: 4, name: "policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "notification_config", kind: "message", T: () => NotificationConfig },
            { no: 7, name: "scope_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessReviewScopeType", AccessReviewScopeType, "ACCESS_REVIEW_SCOPE_TYPE_"] },
            { no: 8, name: "scope", kind: "message", T: () => AccessReviewScopeV2 }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceCreateRequest>): AccessReviewTemplateServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.policyId = "";
        message.ownerIds = [];
        message.scopeType = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceCreateRequest): AccessReviewTemplateServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Duration access_review_duration */ 3:
                    message.accessReviewDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewDuration);
                    break;
                case /* string policy_id */ 4:
                    message.policyId = reader.string();
                    break;
                case /* repeated string owner_ids */ 5:
                    message.ownerIds.push(reader.string());
                    break;
                case /* c1.api.accessreview.v1.NotificationConfig notification_config */ 6:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeType scope_type */ 7:
                    message.scopeType = reader.int32();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeV2 scope */ 8:
                    message.scope = AccessReviewScopeV2.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Duration access_review_duration = 3; */
        if (message.accessReviewDuration)
            Duration.internalBinaryWrite(message.accessReviewDuration, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string policy_id = 4; */
        if (message.policyId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.policyId);
        /* repeated string owner_ids = 5; */
        for (let i = 0; i < message.ownerIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.ownerIds[i]);
        /* c1.api.accessreview.v1.NotificationConfig notification_config = 6; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccessReviewScopeType scope_type = 7; */
        if (message.scopeType !== 0)
            writer.tag(7, WireType.Varint).int32(message.scopeType);
        /* c1.api.accessreview.v1.AccessReviewScopeV2 scope = 8; */
        if (message.scope)
            AccessReviewScopeV2.internalBinaryWrite(message.scope, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateRequest
 */
export const AccessReviewTemplateServiceCreateRequest = new AccessReviewTemplateServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceCreateResponse$Type extends MessageType<AccessReviewTemplateServiceCreateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceCreateResponse", [
            { no: 1, name: "access_review_template", kind: "message", T: () => AccessReviewTemplate }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceCreateResponse>): AccessReviewTemplateServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceCreateResponse): AccessReviewTemplateServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewTemplate access_review_template */ 1:
                    message.accessReviewTemplate = AccessReviewTemplate.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewTemplate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1; */
        if (message.accessReviewTemplate)
            AccessReviewTemplate.internalBinaryWrite(message.accessReviewTemplate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateResponse
 */
export const AccessReviewTemplateServiceCreateResponse = new AccessReviewTemplateServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceDeleteRequest$Type extends MessageType<AccessReviewTemplateServiceDeleteRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceDeleteRequest>): AccessReviewTemplateServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceDeleteRequest): AccessReviewTemplateServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteRequest
 */
export const AccessReviewTemplateServiceDeleteRequest = new AccessReviewTemplateServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceDeleteResponse$Type extends MessageType<AccessReviewTemplateServiceDeleteResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceDeleteResponse>): AccessReviewTemplateServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceDeleteResponse): AccessReviewTemplateServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceDeleteResponse
 */
export const AccessReviewTemplateServiceDeleteResponse = new AccessReviewTemplateServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListRequest$Type extends MessageType<AccessReviewTemplateServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceListRequest>): AccessReviewTemplateServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceListRequest): AccessReviewTemplateServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListRequest
 */
export const AccessReviewTemplateServiceListRequest = new AccessReviewTemplateServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListResponse$Type extends MessageType<AccessReviewTemplateServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplate },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceListResponse>): AccessReviewTemplateServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceListResponse): AccessReviewTemplateServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplate list */ 1:
                    message.list.push(AccessReviewTemplate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewTemplate list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewTemplate.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListResponse
 */
export const AccessReviewTemplateServiceListResponse = new AccessReviewTemplateServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchRequest$Type extends MessageType<AccessReviewTemplateServiceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "sort_options", kind: "message", T: () => SortOptions },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateRef },
            { no: 6, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceSearchRequest>): AccessReviewTemplateServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        message.policyRefs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceSearchRequest): AccessReviewTemplateServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* c1.api.search.v1.SortOptions sort_options */ 4:
                    message.sortOptions = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sortOptions);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateRef refs */ 5:
                    message.refs.push(AccessReviewTemplateRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.policy.v1.PolicyRef policy_refs */ 6:
                    message.policyRefs.push(PolicyRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* c1.api.search.v1.SortOptions sort_options = 4; */
        if (message.sortOptions)
            SortOptions.internalBinaryWrite(message.sortOptions, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewTemplateRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.policy.v1.PolicyRef policy_refs = 6; */
        for (let i = 0; i < message.policyRefs.length; i++)
            PolicyRef.internalBinaryWrite(message.policyRefs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchRequest
 */
export const AccessReviewTemplateServiceSearchRequest = new AccessReviewTemplateServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchResponse$Type extends MessageType<AccessReviewTemplateServiceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplate },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceSearchResponse>): AccessReviewTemplateServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceSearchResponse): AccessReviewTemplateServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplate list */ 1:
                    message.list.push(AccessReviewTemplate.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewTemplate list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewTemplate.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchResponse
 */
export const AccessReviewTemplateServiceSearchResponse = new AccessReviewTemplateServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceGetRequest$Type extends MessageType<AccessReviewTemplateServiceGetRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceGetRequest>): AccessReviewTemplateServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceGetRequest): AccessReviewTemplateServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceGetRequest
 */
export const AccessReviewTemplateServiceGetRequest = new AccessReviewTemplateServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceGetResponse$Type extends MessageType<AccessReviewTemplateServiceGetResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceGetResponse", [
            { no: 1, name: "access_review_template", kind: "message", T: () => AccessReviewTemplate }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceGetResponse>): AccessReviewTemplateServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceGetResponse): AccessReviewTemplateServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewTemplate access_review_template */ 1:
                    message.accessReviewTemplate = AccessReviewTemplate.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewTemplate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1; */
        if (message.accessReviewTemplate)
            AccessReviewTemplate.internalBinaryWrite(message.accessReviewTemplate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceGetResponse
 */
export const AccessReviewTemplateServiceGetResponse = new AccessReviewTemplateServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListOwnersRequest$Type extends MessageType<AccessReviewTemplateServiceListOwnersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceListOwnersRequest>): AccessReviewTemplateServiceListOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceListOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceListOwnersRequest): AccessReviewTemplateServiceListOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceListOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersRequest
 */
export const AccessReviewTemplateServiceListOwnersRequest = new AccessReviewTemplateServiceListOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListOwnersResponse$Type extends MessageType<AccessReviewTemplateServiceListOwnersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceListOwnersResponse>): AccessReviewTemplateServiceListOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceListOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceListOwnersResponse): AccessReviewTemplateServiceListOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceListOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListOwnersResponse
 */
export const AccessReviewTemplateServiceListOwnersResponse = new AccessReviewTemplateServiceListOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchOwnersRequest$Type extends MessageType<AccessReviewTemplateServiceSearchOwnersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateOwnerRef },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceSearchOwnersRequest>): AccessReviewTemplateServiceSearchOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.accessReviewTemplateId = "";
        message.refs = [];
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceSearchOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceSearchOwnersRequest): AccessReviewTemplateServiceSearchOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string access_review_template_id */ 3:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateOwnerRef refs */ 4:
                    message.refs.push(AccessReviewTemplateOwnerRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string user_ids */ 5:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceSearchOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string access_review_template_id = 3; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateOwnerRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewTemplateOwnerRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string user_ids = 5; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersRequest
 */
export const AccessReviewTemplateServiceSearchOwnersRequest = new AccessReviewTemplateServiceSearchOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchOwnerView$Type extends MessageType<AccessReviewTemplateServiceSearchOwnerView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceSearchOwnerView>): AccessReviewTemplateServiceSearchOwnerView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceSearchOwnerView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceSearchOwnerView): AccessReviewTemplateServiceSearchOwnerView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* string access_review_template_id */ 2:
                    message.accessReviewTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceSearchOwnerView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string access_review_template_id = 2; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView
 */
export const AccessReviewTemplateServiceSearchOwnerView = new AccessReviewTemplateServiceSearchOwnerView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSearchOwnersResponse$Type extends MessageType<AccessReviewTemplateServiceSearchOwnersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateServiceSearchOwnerView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceSearchOwnersResponse>): AccessReviewTemplateServiceSearchOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceSearchOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceSearchOwnersResponse): AccessReviewTemplateServiceSearchOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView list */ 1:
                    message.list.push(AccessReviewTemplateServiceSearchOwnerView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceSearchOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnerView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewTemplateServiceSearchOwnerView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSearchOwnersResponse
 */
export const AccessReviewTemplateServiceSearchOwnersResponse = new AccessReviewTemplateServiceSearchOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceUpdateRequest$Type extends MessageType<AccessReviewTemplateServiceUpdateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateRequest", [
            { no: 1, name: "access_review_template", kind: "message", T: () => AccessReviewTemplate },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceUpdateRequest>): AccessReviewTemplateServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceUpdateRequest): AccessReviewTemplateServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewTemplate access_review_template */ 1:
                    message.accessReviewTemplate = AccessReviewTemplate.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewTemplate);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1; */
        if (message.accessReviewTemplate)
            AccessReviewTemplate.internalBinaryWrite(message.accessReviewTemplate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateRequest
 */
export const AccessReviewTemplateServiceUpdateRequest = new AccessReviewTemplateServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceUpdateResponse$Type extends MessageType<AccessReviewTemplateServiceUpdateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateResponse", [
            { no: 1, name: "access_review_template", kind: "message", T: () => AccessReviewTemplate }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceUpdateResponse>): AccessReviewTemplateServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceUpdateResponse): AccessReviewTemplateServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewTemplate access_review_template */ 1:
                    message.accessReviewTemplate = AccessReviewTemplate.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewTemplate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewTemplate access_review_template = 1; */
        if (message.accessReviewTemplate)
            AccessReviewTemplate.internalBinaryWrite(message.accessReviewTemplate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceUpdateResponse
 */
export const AccessReviewTemplateServiceUpdateResponse = new AccessReviewTemplateServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSetOwnersRequest$Type extends MessageType<AccessReviewTemplateServiceSetOwnersRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceSetOwnersRequest>): AccessReviewTemplateServiceSetOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        message.ownerIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceSetOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceSetOwnersRequest): AccessReviewTemplateServiceSetOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* repeated string owner_ids */ 2:
                    message.ownerIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceSetOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* repeated string owner_ids = 2; */
        for (let i = 0; i < message.ownerIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.ownerIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersRequest
 */
export const AccessReviewTemplateServiceSetOwnersRequest = new AccessReviewTemplateServiceSetOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceSetOwnersResponse$Type extends MessageType<AccessReviewTemplateServiceSetOwnersResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersResponse", []);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceSetOwnersResponse>): AccessReviewTemplateServiceSetOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceSetOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceSetOwnersResponse): AccessReviewTemplateServiceSetOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceSetOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceSetOwnersResponse
 */
export const AccessReviewTemplateServiceSetOwnersResponse = new AccessReviewTemplateServiceSetOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListAccessReviewsRequest$Type extends MessageType<AccessReviewTemplateServiceListAccessReviewsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: false } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceListAccessReviewsRequest>): AccessReviewTemplateServiceListAccessReviewsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceListAccessReviewsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceListAccessReviewsRequest): AccessReviewTemplateServiceListAccessReviewsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceListAccessReviewsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsRequest
 */
export const AccessReviewTemplateServiceListAccessReviewsRequest = new AccessReviewTemplateServiceListAccessReviewsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceListAccessReviewsResponse$Type extends MessageType<AccessReviewTemplateServiceListAccessReviewsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceListAccessReviewsResponse>): AccessReviewTemplateServiceListAccessReviewsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceListAccessReviewsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceListAccessReviewsResponse): AccessReviewTemplateServiceListAccessReviewsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewView list */ 1:
                    message.list.push(AccessReviewView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceListAccessReviewsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceListAccessReviewsResponse
 */
export const AccessReviewTemplateServiceListAccessReviewsResponse = new AccessReviewTemplateServiceListAccessReviewsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateRef$Type extends MessageType<AccessReviewTemplateRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateRef>): AccessReviewTemplateRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateRef): AccessReviewTemplateRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateRef
 */
export const AccessReviewTemplateRef = new AccessReviewTemplateRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateOwnerRef$Type extends MessageType<AccessReviewTemplateOwnerRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateOwnerRef", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateOwnerRef>): AccessReviewTemplateOwnerRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.accessReviewTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateOwnerRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateOwnerRef): AccessReviewTemplateOwnerRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string access_review_template_id */ 2:
                    message.accessReviewTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateOwnerRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string access_review_template_id = 2; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateOwnerRef
 */
export const AccessReviewTemplateOwnerRef = new AccessReviewTemplateOwnerRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest$Type extends MessageType<AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest>): AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest): AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest
 */
export const AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest = new AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse$Type extends MessageType<AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse>): AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse): AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse
 */
export const AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse = new AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateAppResourceRollupItem$Type extends MessageType<AccessReviewTemplateAppResourceRollupItem> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResource },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateAppEntitlementView },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateAppResourceRollupItem>): AccessReviewTemplateAppResourceRollupItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlements = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateAppResourceRollupItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateAppResourceRollupItem): AccessReviewTemplateAppResourceRollupItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppResource item */ 1:
                    message.item = AppResource.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView entitlements */ 2:
                    message.entitlements.push(AccessReviewTemplateAppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateAppResourceRollupItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppResource item = 1; */
        if (message.item)
            AppResource.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView entitlements = 2; */
        for (let i = 0; i < message.entitlements.length; i++)
            AccessReviewTemplateAppEntitlementView.internalBinaryWrite(message.entitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem
 */
export const AccessReviewTemplateAppResourceRollupItem = new AccessReviewTemplateAppResourceRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateAppEntitlementView$Type extends MessageType<AccessReviewTemplateAppEntitlementView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "policy_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateAppEntitlementView>): AccessReviewTemplateAppEntitlementView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.policyPath = "";
        message.appResourceTypePath = "";
        message.appResourcePath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateAppEntitlementView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateAppEntitlementView): AccessReviewTemplateAppEntitlementView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlement app_entitlement */ 1:
                    message.appEntitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlement);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string policy_path */ 3:
                    message.policyPath = reader.string();
                    break;
                case /* string app_resource_type_path */ 4:
                    message.appResourceTypePath = reader.string();
                    break;
                case /* string app_resource_path */ 5:
                    message.appResourcePath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateAppEntitlementView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlement app_entitlement = 1; */
        if (message.appEntitlement)
            AppEntitlement.internalBinaryWrite(message.appEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string policy_path = 3; */
        if (message.policyPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.policyPath);
        /* string app_resource_type_path = 4; */
        if (message.appResourceTypePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appResourceTypePath);
        /* string app_resource_path = 5; */
        if (message.appResourcePath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appResourcePath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementView
 */
export const AccessReviewTemplateAppEntitlementView = new AccessReviewTemplateAppEntitlementView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewScopeV2$Type extends MessageType<AccessReviewScopeV2> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewScopeV2", [
            { no: 100, name: "app_access", kind: "message", oneof: "appsAndResourcesScope", T: () => ApplicationAccessScope },
            { no: 101, name: "specific_resources", kind: "message", oneof: "appsAndResourcesScope", T: () => SpecificResourcesScope },
            { no: 102, name: "app_selection_criteria", kind: "message", oneof: "appsAndResourcesScope", T: () => AppSelectionCriteriaScope },
            { no: 103, name: "resource_type_selections", kind: "message", oneof: "appsAndResourcesScope", T: () => ResourceTypeSelectionScope },
            { no: 200, name: "all_users", kind: "message", oneof: "usersScope", T: () => AllUsersScope },
            { no: 201, name: "selected_users", kind: "message", oneof: "usersScope", T: () => SelectedUsersScope },
            { no: 202, name: "user_criteria", kind: "message", oneof: "usersScope", T: () => UserCriteriaScope },
            { no: 203, name: "cel_expression", kind: "message", oneof: "usersScope", T: () => CelExpressionScope },
            { no: 300, name: "all_accounts", kind: "message", oneof: "accountsScope", T: () => AllAccountsScope },
            { no: 301, name: "account_criteria", kind: "message", oneof: "accountsScope", T: () => AccountCriteriaScope },
            { no: 302, name: "account_cel_expression", kind: "message", oneof: "accountsScope", T: () => CelExpressionScope },
            { no: 400, name: "all_grants", kind: "message", oneof: "grantsScope", T: () => AllGrantsScope },
            { no: 401, name: "grants_by_criteria", kind: "message", oneof: "grantsScope", T: () => GrantsByCriteriaScope },
            { no: 500, name: "all_access_conflicts", kind: "message", oneof: "accessConflictsScope", T: () => AllAccessConflictsScope },
            { no: 501, name: "specific_access_conflicts", kind: "message", oneof: "accessConflictsScope", T: () => SpecificAccessConflictsScope }
        ]);
    }
    create(value?: PartialMessage<AccessReviewScopeV2>): AccessReviewScopeV2 {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appsAndResourcesScope = { oneofKind: undefined };
        message.usersScope = { oneofKind: undefined };
        message.accountsScope = { oneofKind: undefined };
        message.grantsScope = { oneofKind: undefined };
        message.accessConflictsScope = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AccessReviewScopeV2>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewScopeV2): AccessReviewScopeV2 {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.ApplicationAccessScope app_access */ 100:
                    message.appsAndResourcesScope = {
                        oneofKind: "appAccess",
                        appAccess: ApplicationAccessScope.internalBinaryRead(reader, reader.uint32(), options, (message.appsAndResourcesScope as any).appAccess)
                    };
                    break;
                case /* c1.api.accessreview.v1.SpecificResourcesScope specific_resources */ 101:
                    message.appsAndResourcesScope = {
                        oneofKind: "specificResources",
                        specificResources: SpecificResourcesScope.internalBinaryRead(reader, reader.uint32(), options, (message.appsAndResourcesScope as any).specificResources)
                    };
                    break;
                case /* c1.api.accessreview.v1.AppSelectionCriteriaScope app_selection_criteria */ 102:
                    message.appsAndResourcesScope = {
                        oneofKind: "appSelectionCriteria",
                        appSelectionCriteria: AppSelectionCriteriaScope.internalBinaryRead(reader, reader.uint32(), options, (message.appsAndResourcesScope as any).appSelectionCriteria)
                    };
                    break;
                case /* c1.api.accessreview.v1.ResourceTypeSelectionScope resource_type_selections */ 103:
                    message.appsAndResourcesScope = {
                        oneofKind: "resourceTypeSelections",
                        resourceTypeSelections: ResourceTypeSelectionScope.internalBinaryRead(reader, reader.uint32(), options, (message.appsAndResourcesScope as any).resourceTypeSelections)
                    };
                    break;
                case /* c1.api.accessreview.v1.AllUsersScope all_users */ 200:
                    message.usersScope = {
                        oneofKind: "allUsers",
                        allUsers: AllUsersScope.internalBinaryRead(reader, reader.uint32(), options, (message.usersScope as any).allUsers)
                    };
                    break;
                case /* c1.api.accessreview.v1.SelectedUsersScope selected_users */ 201:
                    message.usersScope = {
                        oneofKind: "selectedUsers",
                        selectedUsers: SelectedUsersScope.internalBinaryRead(reader, reader.uint32(), options, (message.usersScope as any).selectedUsers)
                    };
                    break;
                case /* c1.api.accessreview.v1.UserCriteriaScope user_criteria */ 202:
                    message.usersScope = {
                        oneofKind: "userCriteria",
                        userCriteria: UserCriteriaScope.internalBinaryRead(reader, reader.uint32(), options, (message.usersScope as any).userCriteria)
                    };
                    break;
                case /* c1.api.accessreview.v1.CelExpressionScope cel_expression */ 203:
                    message.usersScope = {
                        oneofKind: "celExpression",
                        celExpression: CelExpressionScope.internalBinaryRead(reader, reader.uint32(), options, (message.usersScope as any).celExpression)
                    };
                    break;
                case /* c1.api.accessreview.v1.AllAccountsScope all_accounts */ 300:
                    message.accountsScope = {
                        oneofKind: "allAccounts",
                        allAccounts: AllAccountsScope.internalBinaryRead(reader, reader.uint32(), options, (message.accountsScope as any).allAccounts)
                    };
                    break;
                case /* c1.api.accessreview.v1.AccountCriteriaScope account_criteria */ 301:
                    message.accountsScope = {
                        oneofKind: "accountCriteria",
                        accountCriteria: AccountCriteriaScope.internalBinaryRead(reader, reader.uint32(), options, (message.accountsScope as any).accountCriteria)
                    };
                    break;
                case /* c1.api.accessreview.v1.CelExpressionScope account_cel_expression */ 302:
                    message.accountsScope = {
                        oneofKind: "accountCelExpression",
                        accountCelExpression: CelExpressionScope.internalBinaryRead(reader, reader.uint32(), options, (message.accountsScope as any).accountCelExpression)
                    };
                    break;
                case /* c1.api.accessreview.v1.AllGrantsScope all_grants */ 400:
                    message.grantsScope = {
                        oneofKind: "allGrants",
                        allGrants: AllGrantsScope.internalBinaryRead(reader, reader.uint32(), options, (message.grantsScope as any).allGrants)
                    };
                    break;
                case /* c1.api.accessreview.v1.GrantsByCriteriaScope grants_by_criteria */ 401:
                    message.grantsScope = {
                        oneofKind: "grantsByCriteria",
                        grantsByCriteria: GrantsByCriteriaScope.internalBinaryRead(reader, reader.uint32(), options, (message.grantsScope as any).grantsByCriteria)
                    };
                    break;
                case /* c1.api.accessreview.v1.AllAccessConflictsScope all_access_conflicts */ 500:
                    message.accessConflictsScope = {
                        oneofKind: "allAccessConflicts",
                        allAccessConflicts: AllAccessConflictsScope.internalBinaryRead(reader, reader.uint32(), options, (message.accessConflictsScope as any).allAccessConflicts)
                    };
                    break;
                case /* c1.api.accessreview.v1.SpecificAccessConflictsScope specific_access_conflicts */ 501:
                    message.accessConflictsScope = {
                        oneofKind: "specificAccessConflicts",
                        specificAccessConflicts: SpecificAccessConflictsScope.internalBinaryRead(reader, reader.uint32(), options, (message.accessConflictsScope as any).specificAccessConflicts)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewScopeV2, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.ApplicationAccessScope app_access = 100; */
        if (message.appsAndResourcesScope.oneofKind === "appAccess")
            ApplicationAccessScope.internalBinaryWrite(message.appsAndResourcesScope.appAccess, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.SpecificResourcesScope specific_resources = 101; */
        if (message.appsAndResourcesScope.oneofKind === "specificResources")
            SpecificResourcesScope.internalBinaryWrite(message.appsAndResourcesScope.specificResources, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AppSelectionCriteriaScope app_selection_criteria = 102; */
        if (message.appsAndResourcesScope.oneofKind === "appSelectionCriteria")
            AppSelectionCriteriaScope.internalBinaryWrite(message.appsAndResourcesScope.appSelectionCriteria, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.ResourceTypeSelectionScope resource_type_selections = 103; */
        if (message.appsAndResourcesScope.oneofKind === "resourceTypeSelections")
            ResourceTypeSelectionScope.internalBinaryWrite(message.appsAndResourcesScope.resourceTypeSelections, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AllUsersScope all_users = 200; */
        if (message.usersScope.oneofKind === "allUsers")
            AllUsersScope.internalBinaryWrite(message.usersScope.allUsers, writer.tag(200, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.SelectedUsersScope selected_users = 201; */
        if (message.usersScope.oneofKind === "selectedUsers")
            SelectedUsersScope.internalBinaryWrite(message.usersScope.selectedUsers, writer.tag(201, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.UserCriteriaScope user_criteria = 202; */
        if (message.usersScope.oneofKind === "userCriteria")
            UserCriteriaScope.internalBinaryWrite(message.usersScope.userCriteria, writer.tag(202, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.CelExpressionScope cel_expression = 203; */
        if (message.usersScope.oneofKind === "celExpression")
            CelExpressionScope.internalBinaryWrite(message.usersScope.celExpression, writer.tag(203, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AllAccountsScope all_accounts = 300; */
        if (message.accountsScope.oneofKind === "allAccounts")
            AllAccountsScope.internalBinaryWrite(message.accountsScope.allAccounts, writer.tag(300, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AccountCriteriaScope account_criteria = 301; */
        if (message.accountsScope.oneofKind === "accountCriteria")
            AccountCriteriaScope.internalBinaryWrite(message.accountsScope.accountCriteria, writer.tag(301, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.CelExpressionScope account_cel_expression = 302; */
        if (message.accountsScope.oneofKind === "accountCelExpression")
            CelExpressionScope.internalBinaryWrite(message.accountsScope.accountCelExpression, writer.tag(302, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AllGrantsScope all_grants = 400; */
        if (message.grantsScope.oneofKind === "allGrants")
            AllGrantsScope.internalBinaryWrite(message.grantsScope.allGrants, writer.tag(400, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.GrantsByCriteriaScope grants_by_criteria = 401; */
        if (message.grantsScope.oneofKind === "grantsByCriteria")
            GrantsByCriteriaScope.internalBinaryWrite(message.grantsScope.grantsByCriteria, writer.tag(401, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.AllAccessConflictsScope all_access_conflicts = 500; */
        if (message.accessConflictsScope.oneofKind === "allAccessConflicts")
            AllAccessConflictsScope.internalBinaryWrite(message.accessConflictsScope.allAccessConflicts, writer.tag(500, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.SpecificAccessConflictsScope specific_access_conflicts = 501; */
        if (message.accessConflictsScope.oneofKind === "specificAccessConflicts")
            SpecificAccessConflictsScope.internalBinaryWrite(message.accessConflictsScope.specificAccessConflicts, writer.tag(501, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewScopeV2
 */
export const AccessReviewScopeV2 = new AccessReviewScopeV2$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllAccessConflictsScope$Type extends MessageType<AllAccessConflictsScope> {
    constructor() {
        super("c1.api.accessreview.v1.AllAccessConflictsScope", []);
    }
    create(value?: PartialMessage<AllAccessConflictsScope>): AllAccessConflictsScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AllAccessConflictsScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllAccessConflictsScope): AllAccessConflictsScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllAccessConflictsScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AllAccessConflictsScope
 */
export const AllAccessConflictsScope = new AllAccessConflictsScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpecificAccessConflictsScope$Type extends MessageType<SpecificAccessConflictsScope> {
    constructor() {
        super("c1.api.accessreview.v1.SpecificAccessConflictsScope", []);
    }
    create(value?: PartialMessage<SpecificAccessConflictsScope>): SpecificAccessConflictsScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SpecificAccessConflictsScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpecificAccessConflictsScope): SpecificAccessConflictsScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SpecificAccessConflictsScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SpecificAccessConflictsScope
 */
export const SpecificAccessConflictsScope = new SpecificAccessConflictsScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ApplicationAccessScope$Type extends MessageType<ApplicationAccessScope> {
    constructor() {
        super("c1.api.accessreview.v1.ApplicationAccessScope", []);
    }
    create(value?: PartialMessage<ApplicationAccessScope>): ApplicationAccessScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ApplicationAccessScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ApplicationAccessScope): ApplicationAccessScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ApplicationAccessScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ApplicationAccessScope
 */
export const ApplicationAccessScope = new ApplicationAccessScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpecificResourcesScope$Type extends MessageType<SpecificResourcesScope> {
    constructor() {
        super("c1.api.accessreview.v1.SpecificResourcesScope", []);
    }
    create(value?: PartialMessage<SpecificResourcesScope>): SpecificResourcesScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SpecificResourcesScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpecificResourcesScope): SpecificResourcesScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SpecificResourcesScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SpecificResourcesScope
 */
export const SpecificResourcesScope = new SpecificResourcesScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSelectionCriteriaScope$Type extends MessageType<AppSelectionCriteriaScope> {
    constructor() {
        super("c1.api.accessreview.v1.AppSelectionCriteriaScope", []);
    }
    create(value?: PartialMessage<AppSelectionCriteriaScope>): AppSelectionCriteriaScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppSelectionCriteriaScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppSelectionCriteriaScope): AppSelectionCriteriaScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppSelectionCriteriaScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AppSelectionCriteriaScope
 */
export const AppSelectionCriteriaScope = new AppSelectionCriteriaScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypeSelectionScope$Type extends MessageType<ResourceTypeSelectionScope> {
    constructor() {
        super("c1.api.accessreview.v1.ResourceTypeSelectionScope", []);
    }
    create(value?: PartialMessage<ResourceTypeSelectionScope>): ResourceTypeSelectionScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ResourceTypeSelectionScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceTypeSelectionScope): ResourceTypeSelectionScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceTypeSelectionScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ResourceTypeSelectionScope
 */
export const ResourceTypeSelectionScope = new ResourceTypeSelectionScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllUsersScope$Type extends MessageType<AllUsersScope> {
    constructor() {
        super("c1.api.accessreview.v1.AllUsersScope", []);
    }
    create(value?: PartialMessage<AllUsersScope>): AllUsersScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AllUsersScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllUsersScope): AllUsersScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllUsersScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AllUsersScope
 */
export const AllUsersScope = new AllUsersScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectedUsersScope$Type extends MessageType<SelectedUsersScope> {
    constructor() {
        super("c1.api.accessreview.v1.SelectedUsersScope", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SelectedUsersScope>): SelectedUsersScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<SelectedUsersScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SelectedUsersScope): SelectedUsersScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string user_ids */ 1:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SelectedUsersScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string user_ids = 1; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SelectedUsersScope
 */
export const SelectedUsersScope = new SelectedUsersScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserCriteriaScope$Type extends MessageType<UserCriteriaScope> {
    constructor() {
        super("c1.api.accessreview.v1.UserCriteriaScope", [
            { no: 1, name: "manager_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "user_status", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus$] },
            { no: 3, name: "multi_user_profile_attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => IncludedUserAttributeValues }, options: { "validate.rules": { map: { keys: { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } } } },
            { no: 4, name: "group_app_entitlements_ref", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { maxItems: "10" } } } }
        ]);
    }
    create(value?: PartialMessage<UserCriteriaScope>): UserCriteriaScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.managerUserIds = [];
        message.userStatus = [];
        message.multiUserProfileAttributes = {};
        message.groupAppEntitlementsRef = [];
        if (value !== undefined)
            reflectionMergePartial<UserCriteriaScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserCriteriaScope): UserCriteriaScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string manager_user_ids */ 1:
                    message.managerUserIds.push(reader.string());
                    break;
                case /* repeated c1.api.user.v1.UserStatus user_status */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userStatus.push(reader.int32());
                    else
                        message.userStatus.push(reader.int32());
                    break;
                case /* map<string, c1.api.accessreview.v1.IncludedUserAttributeValues> multi_user_profile_attributes */ 3:
                    this.binaryReadMap3(message.multiUserProfileAttributes, reader, options);
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef group_app_entitlements_ref */ 4:
                    message.groupAppEntitlementsRef.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: UserCriteriaScope["multiUserProfileAttributes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof UserCriteriaScope["multiUserProfileAttributes"] | undefined, val: UserCriteriaScope["multiUserProfileAttributes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = IncludedUserAttributeValues.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accessreview.v1.UserCriteriaScope.multi_user_profile_attributes");
            }
        }
        map[key ?? ""] = val ?? IncludedUserAttributeValues.create();
    }
    internalBinaryWrite(message: UserCriteriaScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string manager_user_ids = 1; */
        for (let i = 0; i < message.managerUserIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.managerUserIds[i]);
        /* repeated c1.api.user.v1.UserStatus user_status = 2; */
        if (message.userStatus.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userStatus.length; i++)
                writer.int32(message.userStatus[i]);
            writer.join();
        }
        /* map<string, c1.api.accessreview.v1.IncludedUserAttributeValues> multi_user_profile_attributes = 3; */
        for (let k of globalThis.Object.keys(message.multiUserProfileAttributes)) {
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            IncludedUserAttributeValues.internalBinaryWrite(message.multiUserProfileAttributes[k], writer, options);
            writer.join().join();
        }
        /* repeated c1.api.app.v1.AppEntitlementRef group_app_entitlements_ref = 4; */
        for (let i = 0; i < message.groupAppEntitlementsRef.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.groupAppEntitlementsRef[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.UserCriteriaScope
 */
export const UserCriteriaScope = new UserCriteriaScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CelExpressionScope$Type extends MessageType<CelExpressionScope> {
    constructor() {
        super("c1.api.accessreview.v1.CelExpressionScope", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CelExpressionScope>): CelExpressionScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        if (value !== undefined)
            reflectionMergePartial<CelExpressionScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CelExpressionScope): CelExpressionScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CelExpressionScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.CelExpressionScope
 */
export const CelExpressionScope = new CelExpressionScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllAccountsScope$Type extends MessageType<AllAccountsScope> {
    constructor() {
        super("c1.api.accessreview.v1.AllAccountsScope", []);
    }
    create(value?: PartialMessage<AllAccountsScope>): AllAccountsScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AllAccountsScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllAccountsScope): AllAccountsScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllAccountsScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AllAccountsScope
 */
export const AllAccountsScope = new AllAccountsScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountCriteriaScope$Type extends MessageType<AccountCriteriaScope> {
    constructor() {
        super("c1.api.accessreview.v1.AccountCriteriaScope", [
            { no: 1, name: "no_account_owner", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserStatus", AppUserStatus, "APP_USER_STATUS_"] },
            { no: 3, name: "account_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.accessreview.v1.AppUserType", AppUserType, "APP_USER_TYPE_"] },
            { no: 4, name: "account_domain", kind: "enum", T: () => ["c1.api.app.v1.AppUserDomain", AppUserDomain, "APP_USER_DOMAIN_"] }
        ]);
    }
    create(value?: PartialMessage<AccountCriteriaScope>): AccountCriteriaScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.noAccountOwner = false;
        message.appUserStatuses = [];
        message.accountTypes = [];
        message.accountDomain = 0;
        if (value !== undefined)
            reflectionMergePartial<AccountCriteriaScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountCriteriaScope): AccountCriteriaScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool no_account_owner */ 1:
                    message.noAccountOwner = reader.bool();
                    break;
                case /* repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserStatuses.push(reader.int32());
                    else
                        message.appUserStatuses.push(reader.int32());
                    break;
                case /* repeated c1.api.accessreview.v1.AppUserType account_types */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountTypes.push(reader.int32());
                    else
                        message.accountTypes.push(reader.int32());
                    break;
                case /* c1.api.app.v1.AppUserDomain account_domain */ 4:
                    message.accountDomain = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountCriteriaScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool no_account_owner = 1; */
        if (message.noAccountOwner !== false)
            writer.tag(1, WireType.Varint).bool(message.noAccountOwner);
        /* repeated c1.api.accessreview.v1.AppUserStatus app_user_statuses = 2; */
        if (message.appUserStatuses.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserStatuses.length; i++)
                writer.int32(message.appUserStatuses[i]);
            writer.join();
        }
        /* repeated c1.api.accessreview.v1.AppUserType account_types = 3; */
        if (message.accountTypes.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountTypes.length; i++)
                writer.int32(message.accountTypes[i]);
            writer.join();
        }
        /* c1.api.app.v1.AppUserDomain account_domain = 4; */
        if (message.accountDomain !== 0)
            writer.tag(4, WireType.Varint).int32(message.accountDomain);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccountCriteriaScope
 */
export const AccountCriteriaScope = new AccountCriteriaScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AllGrantsScope$Type extends MessageType<AllGrantsScope> {
    constructor() {
        super("c1.api.accessreview.v1.AllGrantsScope", []);
    }
    create(value?: PartialMessage<AllGrantsScope>): AllGrantsScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AllGrantsScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AllGrantsScope): AllGrantsScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AllGrantsScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AllGrantsScope
 */
export const AllGrantsScope = new AllGrantsScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantsByCriteriaScope$Type extends MessageType<GrantsByCriteriaScope> {
    constructor() {
        super("c1.api.accessreview.v1.GrantsByCriteriaScope", [
            { no: 100, name: "days_since_added", kind: "message", oneof: "criteriaFilter", T: () => Duration },
            { no: 101, name: "days_since_reviewed", kind: "message", oneof: "criteriaFilter", T: () => Duration },
            { no: 103, name: "grants_added_between", kind: "message", oneof: "criteriaFilter", T: () => GrantsAddedBetween },
            { no: 1, name: "type_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.GrantFilterType", GrantFilterType, "GRANT_FILTER_TYPE_"] },
            { no: 2, name: "days_since_last_used", kind: "message", T: () => Duration },
            { no: 3, name: "source_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.GrantSourceFilter", GrantSourceFilter, "GRANT_SOURCE_FILTER_"] },
            { no: 4, name: "access_profile_filter", kind: "message", T: () => GrantAccessProfileFilter }
        ]);
    }
    create(value?: PartialMessage<GrantsByCriteriaScope>): GrantsByCriteriaScope {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.criteriaFilter = { oneofKind: undefined };
        message.typeFilter = 0;
        message.sourceFilter = 0;
        if (value !== undefined)
            reflectionMergePartial<GrantsByCriteriaScope>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantsByCriteriaScope): GrantsByCriteriaScope {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Duration days_since_added */ 100:
                    message.criteriaFilter = {
                        oneofKind: "daysSinceAdded",
                        daysSinceAdded: Duration.internalBinaryRead(reader, reader.uint32(), options, (message.criteriaFilter as any).daysSinceAdded)
                    };
                    break;
                case /* google.protobuf.Duration days_since_reviewed */ 101:
                    message.criteriaFilter = {
                        oneofKind: "daysSinceReviewed",
                        daysSinceReviewed: Duration.internalBinaryRead(reader, reader.uint32(), options, (message.criteriaFilter as any).daysSinceReviewed)
                    };
                    break;
                case /* c1.api.accessreview.v1.GrantsAddedBetween grants_added_between */ 103:
                    message.criteriaFilter = {
                        oneofKind: "grantsAddedBetween",
                        grantsAddedBetween: GrantsAddedBetween.internalBinaryRead(reader, reader.uint32(), options, (message.criteriaFilter as any).grantsAddedBetween)
                    };
                    break;
                case /* c1.api.accessreview.v1.GrantFilterType type_filter */ 1:
                    message.typeFilter = reader.int32();
                    break;
                case /* google.protobuf.Duration days_since_last_used */ 2:
                    message.daysSinceLastUsed = Duration.internalBinaryRead(reader, reader.uint32(), options, message.daysSinceLastUsed);
                    break;
                case /* c1.api.accessreview.v1.GrantSourceFilter source_filter */ 3:
                    message.sourceFilter = reader.int32();
                    break;
                case /* c1.api.accessreview.v1.GrantAccessProfileFilter access_profile_filter */ 4:
                    message.accessProfileFilter = GrantAccessProfileFilter.internalBinaryRead(reader, reader.uint32(), options, message.accessProfileFilter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantsByCriteriaScope, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.GrantFilterType type_filter = 1; */
        if (message.typeFilter !== 0)
            writer.tag(1, WireType.Varint).int32(message.typeFilter);
        /* google.protobuf.Duration days_since_last_used = 2; */
        if (message.daysSinceLastUsed)
            Duration.internalBinaryWrite(message.daysSinceLastUsed, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.GrantSourceFilter source_filter = 3; */
        if (message.sourceFilter !== 0)
            writer.tag(3, WireType.Varint).int32(message.sourceFilter);
        /* c1.api.accessreview.v1.GrantAccessProfileFilter access_profile_filter = 4; */
        if (message.accessProfileFilter)
            GrantAccessProfileFilter.internalBinaryWrite(message.accessProfileFilter, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration days_since_added = 100; */
        if (message.criteriaFilter.oneofKind === "daysSinceAdded")
            Duration.internalBinaryWrite(message.criteriaFilter.daysSinceAdded, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration days_since_reviewed = 101; */
        if (message.criteriaFilter.oneofKind === "daysSinceReviewed")
            Duration.internalBinaryWrite(message.criteriaFilter.daysSinceReviewed, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessreview.v1.GrantsAddedBetween grants_added_between = 103; */
        if (message.criteriaFilter.oneofKind === "grantsAddedBetween")
            GrantsAddedBetween.internalBinaryWrite(message.criteriaFilter.grantsAddedBetween, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GrantsByCriteriaScope
 */
export const GrantsByCriteriaScope = new GrantsByCriteriaScope$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantsAddedBetween$Type extends MessageType<GrantsAddedBetween> {
    constructor() {
        super("c1.api.accessreview.v1.GrantsAddedBetween", [
            { no: 1, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_date", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<GrantsAddedBetween>): GrantsAddedBetween {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GrantsAddedBetween>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantsAddedBetween): GrantsAddedBetween {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp start_date */ 1:
                    message.startDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startDate);
                    break;
                case /* google.protobuf.Timestamp end_date */ 2:
                    message.endDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endDate);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantsAddedBetween, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp start_date = 1; */
        if (message.startDate)
            Timestamp.internalBinaryWrite(message.startDate, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_date = 2; */
        if (message.endDate)
            Timestamp.internalBinaryWrite(message.endDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GrantsAddedBetween
 */
export const GrantsAddedBetween = new GrantsAddedBetween$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantAccessProfileFilter$Type extends MessageType<GrantAccessProfileFilter> {
    constructor() {
        super("c1.api.accessreview.v1.GrantAccessProfileFilter", [
            { no: 1, name: "filter_type", kind: "enum", T: () => ["c1.api.accessreview.v1.AccessProfileFilterType", AccessProfileFilterType, "ACCESS_PROFILE_FILTER_TYPE_"] },
            { no: 2, name: "excluded_access_profile_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "included_access_profile_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<GrantAccessProfileFilter>): GrantAccessProfileFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filterType = 0;
        message.excludedAccessProfileIds = [];
        message.includedAccessProfileIds = [];
        if (value !== undefined)
            reflectionMergePartial<GrantAccessProfileFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantAccessProfileFilter): GrantAccessProfileFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessProfileFilterType filter_type */ 1:
                    message.filterType = reader.int32();
                    break;
                case /* repeated string excluded_access_profile_ids */ 2:
                    message.excludedAccessProfileIds.push(reader.string());
                    break;
                case /* repeated string included_access_profile_ids */ 3:
                    message.includedAccessProfileIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantAccessProfileFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessProfileFilterType filter_type = 1; */
        if (message.filterType !== 0)
            writer.tag(1, WireType.Varint).int32(message.filterType);
        /* repeated string excluded_access_profile_ids = 2; */
        for (let i = 0; i < message.excludedAccessProfileIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.excludedAccessProfileIds[i]);
        /* repeated string included_access_profile_ids = 3; */
        for (let i = 0; i < message.includedAccessProfileIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.includedAccessProfileIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GrantAccessProfileFilter
 */
export const GrantAccessProfileFilter = new GrantAccessProfileFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSource$Type extends MessageType<AccessReviewConnectorSource> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSource", [
            { no: 1, name: "tenant_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "sync_start_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "sync_end_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "connector_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 11, name: "connector_type", kind: "enum", T: () => ["c1.api.accessreview.v1.ConnectorType", ConnectorType, "CONNECTOR_TYPE_"] },
            { no: 12, name: "connector_sync_artifact", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "stats", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ } },
            { no: 14, name: "frozen_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSource>): AccessReviewConnectorSource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tenantId = "";
        message.connectorId = "";
        message.appId = "";
        message.accessReviewId = "";
        message.connectorVersion = 0;
        message.connectorType = 0;
        message.connectorSyncArtifact = "";
        message.stats = {};
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSource): AccessReviewConnectorSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tenant_id */ 1:
                    message.tenantId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string access_review_id */ 4:
                    message.accessReviewId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp sync_start_at */ 8:
                    message.syncStartAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.syncStartAt);
                    break;
                case /* google.protobuf.Timestamp sync_end_at */ 9:
                    message.syncEndAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.syncEndAt);
                    break;
                case /* int64 connector_version */ 10:
                    message.connectorVersion = reader.int64().toNumber();
                    break;
                case /* c1.api.accessreview.v1.ConnectorType connector_type */ 11:
                    message.connectorType = reader.int32();
                    break;
                case /* string connector_sync_artifact */ 12:
                    message.connectorSyncArtifact = reader.string();
                    break;
                case /* map<string, int64> stats */ 13:
                    this.binaryReadMap13(message.stats, reader, options);
                    break;
                case /* google.protobuf.Timestamp frozen_at */ 14:
                    message.frozenAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.frozenAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap13(map: AccessReviewConnectorSource["stats"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AccessReviewConnectorSource["stats"] | undefined, val: AccessReviewConnectorSource["stats"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.int64().toNumber();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.accessreview.v1.AccessReviewConnectorSource.stats");
            }
        }
        map[key ?? ""] = val ?? 0;
    }
    internalBinaryWrite(message: AccessReviewConnectorSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tenant_id = 1; */
        if (message.tenantId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tenantId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string access_review_id = 4; */
        if (message.accessReviewId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.accessReviewId);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sync_start_at = 8; */
        if (message.syncStartAt)
            Timestamp.internalBinaryWrite(message.syncStartAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sync_end_at = 9; */
        if (message.syncEndAt)
            Timestamp.internalBinaryWrite(message.syncEndAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* int64 connector_version = 10; */
        if (message.connectorVersion !== 0)
            writer.tag(10, WireType.Varint).int64(message.connectorVersion);
        /* c1.api.accessreview.v1.ConnectorType connector_type = 11; */
        if (message.connectorType !== 0)
            writer.tag(11, WireType.Varint).int32(message.connectorType);
        /* string connector_sync_artifact = 12; */
        if (message.connectorSyncArtifact !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.connectorSyncArtifact);
        /* map<string, int64> stats = 13; */
        for (let k of globalThis.Object.keys(message.stats))
            writer.tag(13, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).int64(message.stats[k]).join();
        /* google.protobuf.Timestamp frozen_at = 14; */
        if (message.frozenAt)
            Timestamp.internalBinaryWrite(message.frozenAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSource
 */
export const AccessReviewConnectorSource = new AccessReviewConnectorSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceView$Type extends MessageType<AccessReviewConnectorSourceView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceView", [
            { no: 1, name: "access_review_connector_source", kind: "message", T: () => AccessReviewConnectorSource },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sync_lifecycle_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceView>): AccessReviewConnectorSourceView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.connectorPath = "";
        message.syncLifecyclePath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceView): AccessReviewConnectorSourceView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewConnectorSource access_review_connector_source */ 1:
                    message.accessReviewConnectorSource = AccessReviewConnectorSource.internalBinaryRead(reader, reader.uint32(), options, message.accessReviewConnectorSource);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string connector_path */ 3:
                    message.connectorPath = reader.string();
                    break;
                case /* string sync_lifecycle_path */ 4:
                    message.syncLifecyclePath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewConnectorSource access_review_connector_source = 1; */
        if (message.accessReviewConnectorSource)
            AccessReviewConnectorSource.internalBinaryWrite(message.accessReviewConnectorSource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string connector_path = 3; */
        if (message.connectorPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorPath);
        /* string sync_lifecycle_path = 4; */
        if (message.syncLifecyclePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.syncLifecyclePath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceView
 */
export const AccessReviewConnectorSourceView = new AccessReviewConnectorSourceView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceExpandMask$Type extends MessageType<AccessReviewConnectorSourceExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "connector_id", "sync_lifecycle_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceExpandMask>): AccessReviewConnectorSourceExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceExpandMask): AccessReviewConnectorSourceExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask
 */
export const AccessReviewConnectorSourceExpandMask = new AccessReviewConnectorSourceExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceRollupRef$Type extends MessageType<AccessReviewTemplateResourceRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateResourceRollupRef>): AccessReviewTemplateResourceRollupRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appResourceId = "";
        message.accessReviewTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateResourceRollupRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateResourceRollupRef): AccessReviewTemplateResourceRollupRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_resource_id */ 2:
                    message.appResourceId = reader.string();
                    break;
                case /* string access_review_template_id */ 3:
                    message.accessReviewTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateResourceRollupRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_resource_id = 2; */
        if (message.appResourceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appResourceId);
        /* string access_review_template_id = 3; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef
 */
export const AccessReviewTemplateResourceRollupRef = new AccessReviewTemplateResourceRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceRollupSearchRequest$Type extends MessageType<AccessReviewTemplateResourceRollupSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewTemplateAppEntitlementExpandMask },
            { no: 5, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateResourceRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateResourceRollupSearchRequest>): AccessReviewTemplateResourceRollupSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateResourceRollupSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateResourceRollupSearchRequest): AccessReviewTemplateResourceRollupSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AccessReviewTemplateAppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string query */ 5:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef refs */ 6:
                    message.refs.push(AccessReviewTemplateResourceRollupRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateResourceRollupSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewTemplateAppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessReviewTemplateAppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string query = 5; */
        if (message.query !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateResourceRollupRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewTemplateResourceRollupRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchRequest
 */
export const AccessReviewTemplateResourceRollupSearchRequest = new AccessReviewTemplateResourceRollupSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceRollupSearchResponse$Type extends MessageType<AccessReviewTemplateResourceRollupSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateAppResourceRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateResourceRollupSearchResponse>): AccessReviewTemplateResourceRollupSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.accessReviewTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateResourceRollupSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateResourceRollupSearchResponse): AccessReviewTemplateResourceRollupSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem list */ 1:
                    message.list.push(AccessReviewTemplateAppResourceRollupItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* string access_review_template_id */ 3:
                    message.accessReviewTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateResourceRollupSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateAppResourceRollupItem list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewTemplateAppResourceRollupItem.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* string access_review_template_id = 3; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceRollupSearchResponse
 */
export const AccessReviewTemplateResourceRollupSearchResponse = new AccessReviewTemplateResourceRollupSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceTypeRollupItem$Type extends MessageType<AccessReviewTemplateResourceTypeRollupItem> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResourceTypeView },
            { no: 2, name: "resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateResourceTypeRollupItem>): AccessReviewTemplateResourceTypeRollupItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceCount = 0;
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateResourceTypeRollupItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateResourceTypeRollupItem): AccessReviewTemplateResourceTypeRollupItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppResourceTypeView item */ 1:
                    message.item = AppResourceTypeView.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                case /* int64 resource_count */ 2:
                    message.resourceCount = reader.int64().toNumber();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateResourceTypeRollupItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppResourceTypeView item = 1; */
        if (message.item)
            AppResourceTypeView.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 resource_count = 2; */
        if (message.resourceCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.resourceCount);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem
 */
export const AccessReviewTemplateResourceTypeRollupItem = new AccessReviewTemplateResourceTypeRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateResourceTypeRollupRef$Type extends MessageType<AccessReviewTemplateResourceTypeRollupRef> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateResourceTypeRollupRef>): AccessReviewTemplateResourceTypeRollupRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appResourceTypeId = "";
        message.accessReviewTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateResourceTypeRollupRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateResourceTypeRollupRef): AccessReviewTemplateResourceTypeRollupRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_resource_type_id */ 2:
                    message.appResourceTypeId = reader.string();
                    break;
                case /* string access_review_template_id */ 3:
                    message.accessReviewTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateResourceTypeRollupRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_resource_type_id = 2; */
        if (message.appResourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appResourceTypeId);
        /* string access_review_template_id = 3; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef
 */
export const AccessReviewTemplateResourceTypeRollupRef = new AccessReviewTemplateResourceTypeRollupRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSearchResourceTypeRollupSearchRequest$Type extends MessageType<AccessReviewTemplateSearchResourceTypeRollupSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateResourceTypeRollupRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "200" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateSearchResourceTypeRollupSearchRequest>): AccessReviewTemplateSearchResourceTypeRollupSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateSearchResourceTypeRollupSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateSearchResourceTypeRollupSearchRequest): AccessReviewTemplateSearchResourceTypeRollupSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef refs */ 5:
                    message.refs.push(AccessReviewTemplateResourceTypeRollupRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateSearchResourceTypeRollupSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewTemplateResourceTypeRollupRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchRequest
 */
export const AccessReviewTemplateSearchResourceTypeRollupSearchRequest = new AccessReviewTemplateSearchResourceTypeRollupSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSearchResourceTypeRollupSearchResponse$Type extends MessageType<AccessReviewTemplateSearchResourceTypeRollupSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateResourceTypeRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateSearchResourceTypeRollupSearchResponse>): AccessReviewTemplateSearchResourceTypeRollupSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.accessReviewTemplateId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateSearchResourceTypeRollupSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateSearchResourceTypeRollupSearchResponse): AccessReviewTemplateSearchResourceTypeRollupSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem list */ 1:
                    message.list.push(AccessReviewTemplateResourceTypeRollupItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* string access_review_template_id */ 3:
                    message.accessReviewTemplateId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateSearchResourceTypeRollupSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateResourceTypeRollupItem list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewTemplateResourceTypeRollupItem.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* string access_review_template_id = 3; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSearchResourceTypeRollupSearchResponse
 */
export const AccessReviewTemplateSearchResourceTypeRollupSearchResponse = new AccessReviewTemplateSearchResourceTypeRollupSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidateScopeRequest$Type extends MessageType<ValidateScopeRequest> {
    constructor() {
        super("c1.api.accessreview.v1.ValidateScopeRequest", [
            { no: 1, name: "campaign_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "campaign_type", kind: "enum", T: () => ["c1.api.accessreview.v1.ValidateScopeRequest.CampaignType", ValidateScopeRequest_CampaignType, "CAMPAIGN_TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<ValidateScopeRequest>): ValidateScopeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.campaignId = "";
        message.campaignType = 0;
        if (value !== undefined)
            reflectionMergePartial<ValidateScopeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ValidateScopeRequest): ValidateScopeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string campaign_id */ 1:
                    message.campaignId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.ValidateScopeRequest.CampaignType campaign_type */ 2:
                    message.campaignType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ValidateScopeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string campaign_id = 1; */
        if (message.campaignId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.campaignId);
        /* c1.api.accessreview.v1.ValidateScopeRequest.CampaignType campaign_type = 2; */
        if (message.campaignType !== 0)
            writer.tag(2, WireType.Varint).int32(message.campaignType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ValidateScopeRequest
 */
export const ValidateScopeRequest = new ValidateScopeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceListRequest$Type extends MessageType<AccessReviewConnectorSourceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewConnectorSourceExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceListRequest>): AccessReviewConnectorSourceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceListRequest): AccessReviewConnectorSourceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string access_review_id */ 3:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask */ 4:
                    message.expandMask = AccessReviewConnectorSourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string access_review_id = 3; */
        if (message.accessReviewId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessReviewConnectorSourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceListRequest
 */
export const AccessReviewConnectorSourceListRequest = new AccessReviewConnectorSourceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceListResponse$Type extends MessageType<AccessReviewConnectorSourceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceListResponse>): AccessReviewConnectorSourceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceListResponse): AccessReviewConnectorSourceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list */ 1:
                    message.list.push(AccessReviewConnectorSourceView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewConnectorSourceView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceListResponse
 */
export const AccessReviewConnectorSourceListResponse = new AccessReviewConnectorSourceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceSearchRequest$Type extends MessageType<AccessReviewConnectorSourceSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewConnectorSourceExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceSearchRequest>): AccessReviewConnectorSourceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.accessReviewId = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceSearchRequest): AccessReviewConnectorSourceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string access_review_id */ 4:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask */ 5:
                    message.expandMask = AccessReviewConnectorSourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceRef refs */ 6:
                    message.refs.push(AccessReviewConnectorSourceRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string access_review_id = 4; */
        if (message.accessReviewId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 5; */
        if (message.expandMask)
            AccessReviewConnectorSourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewConnectorSourceRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceSearchRequest
 */
export const AccessReviewConnectorSourceSearchRequest = new AccessReviewConnectorSourceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceSearchResponse$Type extends MessageType<AccessReviewConnectorSourceSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceSearchResponse>): AccessReviewConnectorSourceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceSearchResponse): AccessReviewConnectorSourceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list */ 1:
                    message.list.push(AccessReviewConnectorSourceView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewConnectorSourceView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceSearchResponse
 */
export const AccessReviewConnectorSourceSearchResponse = new AccessReviewConnectorSourceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceOutdatedSearchRequest$Type extends MessageType<AccessReviewConnectorSourceOutdatedSearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AccessReviewConnectorSourceExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceOutdatedSearchRequest>): AccessReviewConnectorSourceOutdatedSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.accessReviewId = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceOutdatedSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceOutdatedSearchRequest): AccessReviewConnectorSourceOutdatedSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string access_review_id */ 4:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask */ 5:
                    message.expandMask = AccessReviewConnectorSourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceRef refs */ 6:
                    message.refs.push(AccessReviewConnectorSourceRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceOutdatedSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string access_review_id = 4; */
        if (message.accessReviewId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.accessreview.v1.AccessReviewConnectorSourceExpandMask expand_mask = 5; */
        if (message.expandMask)
            AccessReviewConnectorSourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AccessReviewConnectorSourceRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchRequest
 */
export const AccessReviewConnectorSourceOutdatedSearchRequest = new AccessReviewConnectorSourceOutdatedSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewConnectorSourceOutdatedSearchResponse$Type extends MessageType<AccessReviewConnectorSourceOutdatedSearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewConnectorSourceView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessReviewConnectorSourceOutdatedSearchResponse>): AccessReviewConnectorSourceOutdatedSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewConnectorSourceOutdatedSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewConnectorSourceOutdatedSearchResponse): AccessReviewConnectorSourceOutdatedSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list */ 1:
                    message.list.push(AccessReviewConnectorSourceView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewConnectorSourceOutdatedSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewConnectorSourceView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewConnectorSourceView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewConnectorSourceOutdatedSearchResponse
 */
export const AccessReviewConnectorSourceOutdatedSearchResponse = new AccessReviewConnectorSourceOutdatedSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetupAccessConflictExpandMask$Type extends MessageType<AccessReviewSetupAccessConflictExpandMask> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "access_conflict_monitor_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSetupAccessConflictExpandMask>): AccessReviewSetupAccessConflictExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSetupAccessConflictExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSetupAccessConflictExpandMask): AccessReviewSetupAccessConflictExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSetupAccessConflictExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask
 */
export const AccessReviewSetupAccessConflictExpandMask = new AccessReviewSetupAccessConflictExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetupAccessConflictView$Type extends MessageType<AccessReviewSetupAccessConflictView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetupAccessConflictView", [
            { no: 1, name: "access_conflict", kind: "message", T: () => AccessReviewSetupAccessConflict },
            { no: 2, name: "access_conflict_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSetupAccessConflictView>): AccessReviewSetupAccessConflictView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessConflictPath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSetupAccessConflictView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSetupAccessConflictView): AccessReviewSetupAccessConflictView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewSetupAccessConflict access_conflict */ 1:
                    message.accessConflict = AccessReviewSetupAccessConflict.internalBinaryRead(reader, reader.uint32(), options, message.accessConflict);
                    break;
                case /* string access_conflict_path */ 2:
                    message.accessConflictPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSetupAccessConflictView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewSetupAccessConflict access_conflict = 1; */
        if (message.accessConflict)
            AccessReviewSetupAccessConflict.internalBinaryWrite(message.accessConflict, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string access_conflict_path = 2; */
        if (message.accessConflictPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessConflictPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflictView
 */
export const AccessReviewSetupAccessConflictView = new AccessReviewSetupAccessConflictView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetupAccessConflict$Type extends MessageType<AccessReviewSetupAccessConflict> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetupAccessConflict", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSetupAccessConflict>): AccessReviewSetupAccessConflict {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.conflictMonitorId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSetupAccessConflict>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSetupAccessConflict): AccessReviewSetupAccessConflict {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string conflict_monitor_id */ 2:
                    message.conflictMonitorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSetupAccessConflict, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string conflict_monitor_id = 2; */
        if (message.conflictMonitorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conflictMonitorId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetupAccessConflict
 */
export const AccessReviewSetupAccessConflict = new AccessReviewSetupAccessConflict$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewByAccessConflictsServiceListRequest$Type extends MessageType<AccessReviewByAccessConflictsServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewSetupAccessConflictExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewByAccessConflictsServiceListRequest>): AccessReviewByAccessConflictsServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewByAccessConflictsServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewByAccessConflictsServiceListRequest): AccessReviewByAccessConflictsServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask expand_mask */ 4:
                    message.expandMask = AccessReviewSetupAccessConflictExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewByAccessConflictsServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessReviewSetupAccessConflictExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListRequest
 */
export const AccessReviewByAccessConflictsServiceListRequest = new AccessReviewByAccessConflictsServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewByAccessConflictsServiceListResponse$Type extends MessageType<AccessReviewByAccessConflictsServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewSetupAccessConflictView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewByAccessConflictsServiceListResponse>): AccessReviewByAccessConflictsServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewByAccessConflictsServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewByAccessConflictsServiceListResponse): AccessReviewByAccessConflictsServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewSetupAccessConflictView list */ 1:
                    message.list.push(AccessReviewSetupAccessConflictView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewByAccessConflictsServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewSetupAccessConflictView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewSetupAccessConflictView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewByAccessConflictsServiceListResponse
 */
export const AccessReviewByAccessConflictsServiceListResponse = new AccessReviewByAccessConflictsServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetScopeByAccessConflictRequest$Type extends MessageType<AccessReviewSetScopeByAccessConflictRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_conflict_monitor_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "scope_v2", kind: "message", T: () => AccessReviewScopeV2 }
        ]);
    }
    create(value?: PartialMessage<AccessReviewSetScopeByAccessConflictRequest>): AccessReviewSetScopeByAccessConflictRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.accessConflictMonitorIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSetScopeByAccessConflictRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSetScopeByAccessConflictRequest): AccessReviewSetScopeByAccessConflictRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* repeated string access_conflict_monitor_ids */ 2:
                    message.accessConflictMonitorIds.push(reader.string());
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 */ 3:
                    message.scopeV2 = AccessReviewScopeV2.internalBinaryRead(reader, reader.uint32(), options, message.scopeV2);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSetScopeByAccessConflictRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* repeated string access_conflict_monitor_ids = 2; */
        for (let i = 0; i < message.accessConflictMonitorIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.accessConflictMonitorIds[i]);
        /* c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 3; */
        if (message.scopeV2)
            AccessReviewScopeV2.internalBinaryWrite(message.scopeV2, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictRequest
 */
export const AccessReviewSetScopeByAccessConflictRequest = new AccessReviewSetScopeByAccessConflictRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewSetScopeByAccessConflictResponse$Type extends MessageType<AccessReviewSetScopeByAccessConflictResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictResponse", []);
    }
    create(value?: PartialMessage<AccessReviewSetScopeByAccessConflictResponse>): AccessReviewSetScopeByAccessConflictResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewSetScopeByAccessConflictResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewSetScopeByAccessConflictResponse): AccessReviewSetScopeByAccessConflictResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewSetScopeByAccessConflictResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewSetScopeByAccessConflictResponse
 */
export const AccessReviewSetScopeByAccessConflictResponse = new AccessReviewSetScopeByAccessConflictResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSetupAccessConflictView$Type extends MessageType<AccessReviewTemplateSetupAccessConflictView> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView", [
            { no: 1, name: "access_conflict", kind: "message", T: () => AccessReviewTemplateSetupAccessConflict },
            { no: 2, name: "access_conflict_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateSetupAccessConflictView>): AccessReviewTemplateSetupAccessConflictView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessConflictPath = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateSetupAccessConflictView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateSetupAccessConflictView): AccessReviewTemplateSetupAccessConflictView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict access_conflict */ 1:
                    message.accessConflict = AccessReviewTemplateSetupAccessConflict.internalBinaryRead(reader, reader.uint32(), options, message.accessConflict);
                    break;
                case /* string access_conflict_path */ 2:
                    message.accessConflictPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateSetupAccessConflictView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict access_conflict = 1; */
        if (message.accessConflict)
            AccessReviewTemplateSetupAccessConflict.internalBinaryWrite(message.accessConflict, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string access_conflict_path = 2; */
        if (message.accessConflictPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessConflictPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView
 */
export const AccessReviewTemplateSetupAccessConflictView = new AccessReviewTemplateSetupAccessConflictView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSetupAccessConflict$Type extends MessageType<AccessReviewTemplateSetupAccessConflict> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "conflict_monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateSetupAccessConflict>): AccessReviewTemplateSetupAccessConflict {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        message.conflictMonitorId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateSetupAccessConflict>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateSetupAccessConflict): AccessReviewTemplateSetupAccessConflict {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* string conflict_monitor_id */ 2:
                    message.conflictMonitorId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateSetupAccessConflict, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* string conflict_monitor_id = 2; */
        if (message.conflictMonitorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conflictMonitorId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflict
 */
export const AccessReviewTemplateSetupAccessConflict = new AccessReviewTemplateSetupAccessConflict$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateByAccessConflictsServiceListRequest$Type extends MessageType<AccessReviewTemplateByAccessConflictsServiceListRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AccessReviewSetupAccessConflictExpandMask }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateByAccessConflictsServiceListRequest>): AccessReviewTemplateByAccessConflictsServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateByAccessConflictsServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateByAccessConflictsServiceListRequest): AccessReviewTemplateByAccessConflictsServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask expand_mask */ 4:
                    message.expandMask = AccessReviewSetupAccessConflictExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateByAccessConflictsServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.accessreview.v1.AccessReviewSetupAccessConflictExpandMask expand_mask = 4; */
        if (message.expandMask)
            AccessReviewSetupAccessConflictExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListRequest
 */
export const AccessReviewTemplateByAccessConflictsServiceListRequest = new AccessReviewTemplateByAccessConflictsServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateByAccessConflictsServiceListResponse$Type extends MessageType<AccessReviewTemplateByAccessConflictsServiceListResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessReviewTemplateSetupAccessConflictView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateByAccessConflictsServiceListResponse>): AccessReviewTemplateByAccessConflictsServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateByAccessConflictsServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateByAccessConflictsServiceListResponse): AccessReviewTemplateByAccessConflictsServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView list */ 1:
                    message.list.push(AccessReviewTemplateSetupAccessConflictView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateByAccessConflictsServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessreview.v1.AccessReviewTemplateSetupAccessConflictView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessReviewTemplateSetupAccessConflictView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateByAccessConflictsServiceListResponse
 */
export const AccessReviewTemplateByAccessConflictsServiceListResponse = new AccessReviewTemplateByAccessConflictsServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSetScopeByAccessConflictRequest$Type extends MessageType<AccessReviewTemplateSetScopeByAccessConflictRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictRequest", [
            { no: 1, name: "access_review_template_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "access_conflict_monitor_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "scope_v2", kind: "message", T: () => AccessReviewScopeV2 }
        ]);
    }
    create(value?: PartialMessage<AccessReviewTemplateSetScopeByAccessConflictRequest>): AccessReviewTemplateSetScopeByAccessConflictRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewTemplateId = "";
        message.accessConflictMonitorIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateSetScopeByAccessConflictRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateSetScopeByAccessConflictRequest): AccessReviewTemplateSetScopeByAccessConflictRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_template_id */ 1:
                    message.accessReviewTemplateId = reader.string();
                    break;
                case /* repeated string access_conflict_monitor_ids */ 2:
                    message.accessConflictMonitorIds.push(reader.string());
                    break;
                case /* c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 */ 3:
                    message.scopeV2 = AccessReviewScopeV2.internalBinaryRead(reader, reader.uint32(), options, message.scopeV2);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateSetScopeByAccessConflictRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_template_id = 1; */
        if (message.accessReviewTemplateId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewTemplateId);
        /* repeated string access_conflict_monitor_ids = 2; */
        for (let i = 0; i < message.accessConflictMonitorIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.accessConflictMonitorIds[i]);
        /* c1.api.accessreview.v1.AccessReviewScopeV2 scope_v2 = 3; */
        if (message.scopeV2)
            AccessReviewScopeV2.internalBinaryWrite(message.scopeV2, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictRequest
 */
export const AccessReviewTemplateSetScopeByAccessConflictRequest = new AccessReviewTemplateSetScopeByAccessConflictRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewTemplateSetScopeByAccessConflictResponse$Type extends MessageType<AccessReviewTemplateSetScopeByAccessConflictResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictResponse", []);
    }
    create(value?: PartialMessage<AccessReviewTemplateSetScopeByAccessConflictResponse>): AccessReviewTemplateSetScopeByAccessConflictResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewTemplateSetScopeByAccessConflictResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewTemplateSetScopeByAccessConflictResponse): AccessReviewTemplateSetScopeByAccessConflictResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewTemplateSetScopeByAccessConflictResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewTemplateSetScopeByAccessConflictResponse
 */
export const AccessReviewTemplateSetScopeByAccessConflictResponse = new AccessReviewTemplateSetScopeByAccessConflictResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewService
 */
export const AccessReviewService = new ServiceType("c1.api.accessreview.v1.AccessReviewService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/access_review/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access Review" }], group: "Access Review" }] } }, I: AccessReviewServiceGetRequest, O: AccessReviewServiceGetResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/access_review", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access Review" }], group: "Access Review" }] } }, I: AccessReviewServiceCreateRequest, O: AccessReviewServiceCreateResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/access_review/{access_review.id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access Review" }], group: "Access Review" }] } }, I: AccessReviewServiceUpdateRequest, O: AccessReviewServiceUpdateResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/access_reviews", query: { page_size: "page_size", page_token: "page_token" }, stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access Reviews" }], group: "Access Review" }] } }, I: AccessReviewServiceListRequest, O: AccessReviewServiceListResponse },
    { name: "ListEntitlementsWithMultiApp", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewServiceListEntitlementsWithMultiAppRequest, O: AccessReviewServiceListEntitlementsWithMultiAppResponse },
    { name: "Delete", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/access_review/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access Review" }], group: "Access Review" }] } }, I: AccessReviewServiceDeleteRequest, O: AccessReviewServiceDeleteResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewReportService
 */
export const AccessReviewReportService = new ServiceType("c1.api.accessreview.v1.AccessReviewReportService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewReportServiceListRequest, O: AccessReviewReportServiceListResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewEntitlementPreviewService
 */
export const AccessReviewEntitlementPreviewService = new ServiceType("c1.api.accessreview.v1.AccessReviewEntitlementPreviewService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewEntitlementPreviewServiceSearchRequest, O: AccessReviewEntitlementPreviewServiceSearchResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewTemplateService
 */
export const AccessReviewTemplateService = new ServiceType("c1.api.accessreview.v1.AccessReviewTemplateService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/access_review_template", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access Review Template" }], group: "Access Review Template" }] } }, I: AccessReviewTemplateServiceCreateRequest, O: AccessReviewTemplateServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/access_review_template/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access Review Template" }], group: "Access Review Template" }] } }, I: AccessReviewTemplateServiceDeleteRequest, O: AccessReviewTemplateServiceDeleteResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceListRequest, O: AccessReviewTemplateServiceListResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceSearchRequest, O: AccessReviewTemplateServiceSearchResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/access_review_template/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access Review Template" }], group: "Access Review Template" }] } }, I: AccessReviewTemplateServiceGetRequest, O: AccessReviewTemplateServiceGetResponse },
    { name: "ListOwners", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceListOwnersRequest, O: AccessReviewTemplateServiceListOwnersResponse },
    { name: "SetOwners", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewTemplateServiceSetOwnersRequest, O: AccessReviewTemplateServiceSetOwnersResponse },
    { name: "SearchOwners", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceSearchOwnersRequest, O: AccessReviewTemplateServiceSearchOwnersResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/access_review_template/{access_review_template.id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access Review Template" }], group: "Access Review Template" }] } }, I: AccessReviewTemplateServiceUpdateRequest, O: AccessReviewTemplateServiceUpdateResponse },
    { name: "ListAccessReviews", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateServiceListAccessReviewsRequest, O: AccessReviewTemplateServiceListAccessReviewsResponse },
    { name: "CreateAccessReviewFromTemplate", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewTemplateServiceCreateAccessReviewFromTemplateRequest, O: AccessReviewTemplateServiceCreateAccessReviewFromTemplateResponse },
    { name: "SearchTemplateResourceRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateResourceRollupSearchRequest, O: AccessReviewTemplateResourceRollupSearchResponse },
    { name: "SearchTemplateResourceTypeRollup", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateSearchResourceTypeRollupSearchRequest, O: AccessReviewTemplateSearchResourceTypeRollupSearchResponse },
    { name: "ListAccessConflicts", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewTemplateByAccessConflictsServiceListRequest, O: AccessReviewTemplateByAccessConflictsServiceListResponse },
    { name: "SetTemplateCampaignScopeByAccessConflict", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewTemplateSetScopeByAccessConflictRequest, O: AccessReviewTemplateSetScopeByAccessConflictResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewConnectorSourceService
 */
export const AccessReviewConnectorSourceService = new ServiceType("c1.api.accessreview.v1.AccessReviewConnectorSourceService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewConnectorSourceListRequest, O: AccessReviewConnectorSourceListResponse },
    { name: "ListAllOutdatedConnectorSources", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewConnectorSourceServiceListOutdatedRequest, O: AccessReviewConnectorSourceServiceListOutdatedResponse },
    { name: "SearchAccessReviewConnectorSources", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewConnectorSourceSearchRequest, O: AccessReviewConnectorSourceSearchResponse },
    { name: "SearchOutdatedAccessReviewConnectorSources", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewConnectorSourceOutdatedSearchRequest, O: AccessReviewConnectorSourceOutdatedSearchResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewByAccessConflictsService
 */
export const AccessReviewByAccessConflictsService = new ServiceType("c1.api.accessreview.v1.AccessReviewByAccessConflictsService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AccessReviewByAccessConflictsServiceListRequest, O: AccessReviewByAccessConflictsServiceListResponse },
    { name: "SetCampaignScopeByAccessConflict", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewSetScopeByAccessConflictRequest, O: AccessReviewSetScopeByAccessConflictResponse }
]);
